import { JobStatus, modules } from '@veritone/glc-redux';
import { Action, Dispatch, ThunkAction } from '@reduxjs/toolkit';
import callGraphQLApi from '@helpers/callGraphQLApi';
import { DATABASE_UPDATE_DELAY } from '@cbsa-modules/mainPage/services';
import {
  lookupLatestCaseSchemaId,
  lookupLatestTdoLockSchemaId,
} from '@cbsa-modules/universal'; // TODO why are these funciton inside cbsa app?
import {
  CREATE_NEW_FOLDER_SUCCESS,
  CREATE_NEW_FOLDER_FAILURE,
  SEARCH_CASES_AND_FOLDERS_FAILURE,
  DELETE_FOLDER_REQUEST,
  SEARCH_CASES_AND_FOLDERS_INIT,
  FETCH_LEGACY_MEDIAS_INIT,
  FETCH_LEGACY_MEDIAS_SUCCESS,
  FETCH_LEGACY_MEDIAS_FAILURE,
  DELETE_MEDIA_FILE_SDO_FAILURE,
  DELETE_MEDIA_FILE_SDO_SUCCESS,
  FETCH_TDO_DETAIL_FOR_SDOS_SUCCESS,
  FETCH_TDO_DETAIL_FOR_SDOS_FAILURE,
  TDO_IN_USE,
  DELETE_FOLDER_FAILURE,
  DELETE_FOLDER_INIT,
  SOFT_DELETE_FOLDER_SUCCESS,
  SOFT_DELETE_FOLDER_FAILURE,
  actionMoveFolderRequest,
  CHECK_EMPTY_FOLDER_REQUEST,
  CHECK_EMPTY_FOLDER_SUCCESS,
  CHECK_EMPTY_FOLDER_FAILURE,
  LINK_FOLDER_AND_CASE_SDO,
  LINK_FOLDER_AND_CASE_SDO_SUCCESS,
  LINK_FOLDER_AND_CASE_SDO_FAILURE,
  actionSetSearchResults,
  SET_FOLDER_PERMISSIONS,
  FETCH_ROOT_FOLDERS_SUCCESS,
  REFRESH_FILE_OUTPUTS_FAILURE,
  REFRESH_FILE_OUTPUTS_INIT,
  REFRESH_FILE_OUTPUTS_SUCCESS,
  SET_REQUEST_ROSTER,
  APPEND_REQUEST_ROSTER,
  MERGE_CASE_FILE_ROWS,
} from '@redact-modules/casemedia/actions';
import {
  CaseId,
  FolderId,
  TDOId,
  TreeObjectId,
} from '@common/state/modules/universal/models/Brands';
import {
  FolderPermissionFlags,
  FolderStateType,
  SearchResultFile,
} from '@redact-modules/casemedia/store';
import {
  selectSearchText,
  selectSearchDefaultFolderLimit,
  selectSearchDefaultFileLimit,
  selectSearchDefaultOffset,
  selectSearchMoreFilesOffset,
  selectSearchMoreFoldersOffset,
  selectSearchMoreFilesAvailable,
  selectSearchMoreFoldersAvailable,
  selectIsSearchMoreResults,
  selectSearchScopeFolderId,
  selectSearchScopeTreeObjectId,
  selectSearchScopeIsCase,
  selectSearchBarScopeMode,
  selectSearchResults,
  selectSelectedFolders,
  buildSearchCacheKey,
  selectFolderPermissions,
  selectIsOlpEnabled,
  selectRequestRoster,
  selectUnassignedSort,
} from '@redact-modules/casemedia/selectors';
import {
  FolderPathItem,
  resolveFolderMutationId,
  selectAdminRootFolder,
  sortFolderPath,
} from '@redact/state/modules/helper';
import { SYSTEM_FOLDER_REDACT_TRASH } from '@redact-modules/trash/constants';
import { actionPurgeTdoSideData } from '@redact-modules/trash/actions';
import { markTdosPurgeable } from '@redact-modules/trash/pendingPurge';
import {
  createNewFolderQuery,
  createNewFolderLinkQuery,
  createNewFolderSdoQuery,
  searchFolderAndCasesQuery,
  searchFolderByParentQuery,
  SearchFolderByParentQueryResponse,
  deleteSdoQuery,
  fetchLegacyMediasQuery,
  unassignedSortOrderBy,
  getUnassignedTdoDetailsQuery,
  CreateNewFolderQueryResponse,
  CreateNewFolderSdoQueryResponse,
  findActiveTdoLocksQuery,
  findTdoLockQuery,
  getTdoLockContextQuery,
  getChildFoldersQuery,
  getFilesByCaseIdQuery,
  DeleteSdoQueryResponse,
  SoftDeleteSdoQueryResponse,
  SearchFolderAndCasesQueryResponse,
  softDeleteSdoQuery,
  getTdoDetailsQuery,
  FetchLegacyMediasQueryResponse,
  createSoftDeletedFolderSdoQuery,
  CreateSoftDeletedSdoQueryResponse,
  fetchSubFoldersQuery,
  FetchSubFoldersQueryResponse,
  FetchCaseContentsQueryResponse,
  fetchCaseContentsQuery,
  fetchStalenessAssetsQuery,
  StalenessAssetsResponse,
  fetchMediaAssetsQuery,
  MediaAssetsResponse,
  deleteFolderOrCaseQuery,
  fetchRootFoldersQuery,
  FetchRootFoldersQueryResponse,
  fetchRequestRosterQuery,
  FetchRequestRosterQueryResponse,
  fetchCaseFileRowsByIdsQuery,
  FetchCaseFileRowsByIdsQueryResponse,
} from './queries';
import {
  ActionDeleteCaseSdoPayload,
  ActionDeleteMediaFileSdoPayload,
  ActionFetchFolderRequest,
  ActionFetchLegacyMediasRequest,
  ActionSoftDeleteCaseSdoPayload,
} from '@redact-modules/casemedia/models';
import {
  IN_REDACTION_TAG_KEY,
  UpdateTDOLockResponse,
} from '@common-modules/mediaDetails';
import { getRedactionStatusIdentity } from '@common-modules/mediaDetails/redactionStatuses';
import {
  FilesElasticSearchResult,
  Folder,
  TdoDetail,
  TdoSearchDetail,
  TdosDetailsResponse,
} from '@redact-modules/casemedia/models/search';
import { lookupLatestSchemaId } from '@redact-state/modules/mainPage/services';
import { MediaAssetRecord } from '@redact-modules/casemedia/mediaAssets';
import { isRequestInputFile } from '@redact-modules/casemedia/requestMembership';
import type {
  AssetFileType,
  RequestRosterEntry,
} from '@redact-modules/casemedia/store';
import { fetchGraphQLApi } from '@helpers/callApi';
import { LOCK_REFRESH, TDO_LOCK_PAGE_SIZE } from '@helpers/constants';
import { isTdoLockFresh } from '@redact-modules/projects/setLock';
import { resolveFileType } from '@helpers/mediaFile';
import {
  arrayHasContents,
  guid,
  isObjectWithProperty,
  isObjectWithStringProperty,
} from '@common/shared/util';
import { enqueueSnackbar } from '@common/state/modules/snackbar';
import {
  selectFeatureFlags,
  selectRootFolderSmartSelection,
} from '@common/user-permissions';
import { selectV2FoldersEnabled } from '@common/user-onboarding/selectors/organization';
import { Head, NonEmptyArray } from 'ts-essentials';
import { uniq } from 'lodash';

const {
  auth: { selectOAuthToken, selectSessionToken },
  config: { getConfig },
  user: { selectUser, logout },
} = modules;

type Thunk<P, R = any> = (
  payload: P,
  ...args: any[]
) => ThunkAction<Promise<R | undefined>, any, unknown, Action>;

// <T>(query: string, variables: {}, actionTypes: [string, string, string]) =>
const NOOP = 'noop';
export const invokeGqlCall =
  <T>(
    query: string,
    variables: object,
    actionTypes: Head<Parameters<typeof callGraphQLApi<T>>>['actionTypes'],
    // Folder-listing reads select nested `contentTemplates { sdo { data } }`. A
    // folder whose content template points at an already-deleted SDO makes the
    // API answer with the valid records plus a `not_found` for that nested sdo;
    // without this flag callGraphQLApi treats the whole response as a failure and
    // the folder view breaks ("Failed to fetch folders"). Opt read paths into
    // partial-data tolerance so one dangling row can't blank the tree. Mutations
    // must NOT set this — a genuine not_found there should still fail.
    options?: { returnPartialDataOnNotFound?: boolean }
  ) =>
  async (dispatch: Dispatch, getState: () => any) =>
    await callGraphQLApi<T>({
      actionTypes,
      query,
      variables,
      dispatch,
      getState,
      returnPartialDataOnNotFound: options?.returnPartialDataOnNotFound,
    });

// Each action-type slot is typed as a SINGLE function (not a union of the two
// concrete creators) — calling a union of action creators trips "no compatible
// call signature". The meta type is borrowed from the creators themselves via
// `Parameters<>` so nothing new has to be exported from callGraphQLApi.
type RootFoldersSuccessAC = (
  payload: FetchRootFoldersQueryResponse,
  meta: NonNullable<Parameters<typeof FETCH_ROOT_FOLDERS_SUCCESS>[1]>,
  error?: false
) => Action;
type RootFoldersFailureAC = (
  payload: { message: string; name: string }[],
  meta: { variables: { limit: number; offset: number } },
  error?: boolean
) => Action;

export type RootFoldersActionTypes = readonly [
  init: string,
  success: RootFoldersSuccessAC,
  failure: RootFoldersFailureAC,
];

// A GraphQL error is scoped to a NESTED field when its `path` reaches below the
// top-level query field, e.g.
// ["rootFolders", 0, "childFolders", "records", 3, "contentTemplates", 0, "sdo"].
// Under OLP those are the per-object denials this read is meant to survive: the
// server's `@verifyAuthRoleAccess` directive throws `NotAllowed` from inside the
// nested field's own resolver, so the executor always records a deep path (the
// list-level `@authListFilter` never throws at all — it filters in the query).
// An error whose path IS the top-level field, or which carries no path (schema
// validation, auth rejection before execution), rejected the whole read.
const isNestedFieldError = (error: unknown) =>
  isObjectWithProperty(error, 'path') &&
  Array.isArray(error.path) &&
  error.path.length > 1;

// Runs the `listRootFolders` query directly (not through callGraphQLApi) so the
// success/failure decision is based on the presence of usable data, NOT on the
// names of any GraphQL errors. Under object-level permissions the query returns
// the accessible org root in `data` ALONGSIDE `not_allowed` errors (and `null`
// array elements) for objects the caller can't see; callGraphQLApi would treat
// that whole response as a failure and blank the folder view. Any response that
// carries usable `rootFolders` data — or whose only errors are nested per-object
// denials — is a success; only a blocking error with no usable data fails. The
// caller supplies the action-type tuple, so this one thunk serves both the
// initial fetch and the pagination ("load more" of the root's children).
// Because it bypasses callGraphQLApi it must reproduce the two guarantees that
// helper provided: a FAILURE dispatch on a rejected fetch (otherwise the view
// keeps its INIT spinner forever, and trash's root-folder race never settles),
// and logout() on an expired session. See VE-20286.
export const fetchRootFolders =
  (
    payload: ActionFetchFolderRequest,
    [INIT, SUCCESS, FAILURE]: RootFoldersActionTypes
  ) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const { limit = 0, offset = 0 } = payload;
    const variables = { limit, offset };

    dispatch({ type: INIT });

    const oauthToken = selectOAuthToken(getState());
    const sessionToken = selectSessionToken(getState());
    const { apiRoot, graphQLEndpoint, veritoneAppId } =
      getConfig<Window['config']>(getState());

    let response;
    try {
      response = await fetchGraphQLApi<FetchRootFoldersQueryResponse>({
        endpoint: `${apiRoot}/${graphQLEndpoint}`,
        query: fetchRootFoldersQuery,
        variables,
        token: sessionToken || oauthToken,
        veritoneAppId,
      });
    } catch (e) {
      // Transport-level failure (offline, non-JSON 5xx) — there is no GraphQL
      // envelope to inspect. Shape it like a GraphQL error so the FAILURE
      // handler's `payload[0].message` snackbar still reads correctly.
      const message = isObjectWithStringProperty(e, 'message')
        ? e.message
        : 'Unknown Error';
      dispatch(
        FAILURE([{ message, name: 'fetch_error' }], { variables }, true)
      );
      return;
    }

    const meta = {
      variables,
      operationName: undefined,
      query: fetchRootFoldersQuery,
      _internalRequestId: guid(),
      _shouldTrackRequestsIndividually: false,
      response,
    };

    const errors = response.errors ?? [];
    // Nested per-object denials are tolerated; everything else blocks the read.
    const blockingErrors = errors.filter((e) => !isNestedFieldError(e));

    // An expired session rejects the whole request, so it always lands in
    // blockingErrors. callGraphQLApi used to trigger the re-auth for us.
    if (
      blockingErrors.some(
        (e) =>
          isObjectWithStringProperty(e, 'name') &&
          e.name === 'authentication_error'
      )
    ) {
      dispatch(FAILURE(blockingErrors, { variables }, true));
      // logout() is a thunk; nothing here awaits the re-auth redirect.
      void dispatch(logout());
      return;
    }

    if (response.data?.rootFolders || !blockingErrors.length) {
      if (errors.length) {
        // Don't swallow silently — a tolerated error is still worth seeing when
        // diagnosing a folder tree that renders with pieces missing.
        console.debug('listRootFolders returned partial data', errors);
      }
      // OLP returns `null` for sibling roots the caller can't access (the array
      // TYPE says non-null, but the runtime response can contain them). Strip
      // them ONCE here so every downstream consumer — root selection, pagination,
      // reducers — sees only real folders and needs no null handling.
      const rootFolders = (response.data?.rootFolders ?? []).filter(Boolean);
      dispatch(SUCCESS({ rootFolders }, meta));
      return response.data;
    }

    dispatch(FAILURE(blockingErrors, { variables }, true));
  };

export const fetchFolderPermissions =
  (folderIds: FolderId[]) =>
  async (dispatch: Dispatch, getState: () => any) => {
    // The OLP short-circuit lives HERE, not in the callers. Several places ask
    // for these verdicts (menu open, selection change) and a non-OLP org must
    // issue no permission traffic at all — one guard at the entry point is what
    // makes that true regardless of which caller is added next. The selectors
    // short-circuit on the same flag, so an empty cache is never consulted.
    if (!selectIsOlpEnabled(getState())) {
      return;
    }

    const cached = selectFolderPermissions(getState());
    const idsToCheck = uniq(folderIds.filter((id) => id && !(id in cached)));

    if (!idsToCheck.length) {
      return;
    }

    // Three aliases over one `hasPermissions` field: the folder-view actions map
    // onto three DIFFERENT aiWARE permissions (see FolderPermissionFlags), and
    // asking for [UPDATE, FILE, DELETE] in a single `permissions` list would
    // collapse them into one verdict per id and tell us nothing about which of
    // the three was granted. Aliasing keeps them separate in one round trip.
    const query = `
      query checkFolderPermissions(
        $resourceType: AuthResourceType!,
        $ids: [ID!]!
      ) {
        update: hasPermissions(
          resourceType: $resourceType
          ids: $ids
          permissions: [AIWARE_FOLDER_UPDATE]
        ) {
          hasPermission
          id
        }
        file: hasPermissions(
          resourceType: $resourceType
          ids: $ids
          permissions: [AIWARE_FOLDER_FILE]
        ) {
          hasPermission
          id
        }
        delete: hasPermissions(
          resourceType: $resourceType
          ids: $ids
          permissions: [AIWARE_FOLDER_DELETE]
        ) {
          hasPermission
          id
        }
      }
    `;

    try {
      type Verdicts = { hasPermission: boolean; id: string }[];
      const result = await callGraphQLApi<{
        update: Verdicts;
        file: Verdicts;
        delete: Verdicts;
      }>({
        actionTypes: [NOOP, NOOP, NOOP],
        query,
        variables: {
          resourceType: 'Folder',
          ids: idsToCheck,
        },
        dispatch,
        getState,
        bailout: undefined,
      });

      // Absent from a SUCCESSFUL response → not permitted. The server answered
      // and declined to grant this id, which under OLP is how inaccessible
      // resources surface (same omission behaviour documented for rootFolders
      // above). Matches checkTdoPermissions, which also defaults an empty
      // response to false.
      const granted = (verdicts: Verdicts | undefined, id: FolderId) =>
        verdicts?.find((p) => p.id === id)?.hasPermission ?? false;

      const permissionsById: Record<string, FolderPermissionFlags> = {};
      for (const id of idsToCheck) {
        permissionsById[id] = {
          canEdit: granted(result?.update, id),
          canMove: granted(result?.file, id),
          canDelete: granted(result?.delete, id),
        };
      }
      dispatch(SET_FOLDER_PERMISSIONS(permissionsById));
    } catch (e) {
      // Deliberately write NOTHING to the cache on failure. `idsToCheck` filters
      // on this same map, so caching any verdict here would make a single
      // transient error (offline blip, 5xx, a `not_allowed` sibling) permanent
      // for the rest of the session. Leaving the id absent is what makes the
      // gate self-healing: selectCanEditFolder reads an absent id as
      // NOT editable (fail-closed), so the folder is gated for now, and the next
      // menu open re-runs the check instead of being short-circuited by a cached
      // answer.
      console.debug('Error checking folder permissions', e);
    }
  };

/**
 * Deliberately large enough that a real request comes back in ONE page.
 *
 * Not a latency choice — a correctness one. Under Folders v2 the `childTDOs`
 * resolver pages with `LIMIT`/`OFFSET` and NO `ORDER BY`
 * (`dalFolderV2.js` → `getFolderObjects`), so Postgres may return rows in a
 * different order between executions. Paging that is unstable: a file can
 * come back on two pages, and a file can come back on none. Duplicates we can
 * dedupe; an omission is invisible, and an incomplete roster would make
 * "Select All covers the request" quietly false.
 *
 * A single page has no boundary for that to exploit, so the page size is set
 * past the largest request we expect rather than tuned for speed. Beyond it
 * the risk returns, which is why `rosterEntriesFrom` dedupes and why the
 * platform ask is for a deterministic order (see
 * `platform-childTDOs-v2-ordering.md`).
 */
export const REQUEST_ROSTER_PAGE_SIZE = 2000;
/**
 * Pages a request read may take before it gives up — 50,000 files, far past
 * any request Redact is used with today, so it bounds a runaway read (a server
 * that never returns an empty page) rather than a real one. Past it the read
 * reports `error` rather than a list it knows is incomplete.
 */
export const REQUEST_ROSTER_MAX_PAGES = 50;

type RequestRosterRecord = NonNullable<
  NonNullable<
    NonNullable<FetchRequestRosterQueryResponse['folder']>['childTDOs']
  >['records'][number]
>;

/**
 * The roster entries one page of `childTDOs` contributes — the files that are
 * actually in this request, in the shape the folder view sorts and filters.
 *
 * Membership is `isRequestInputFile`, the SAME predicate `mapMediaFiles` uses
 * for the rows it renders (see `requestMembership`), so the list on screen and
 * the roster behind it cannot disagree about what is in the request.
 *
 * A record with no name is dropped: it cannot be sorted, shown or collided
 * with, and every caller treats `name` as present.
 */
export const rosterEntriesFrom = (
  records: readonly (RequestRosterRecord | null)[]
): RequestRosterEntry[] =>
  records
    .filter((tdo): tdo is RequestRosterRecord => !!tdo?.name)
    .filter(isRequestInputFile)
    .map((tdo) => ({
      id: tdo.id,
      name: tdo.name as string,
      // The wire type is deliberately loose; this is the one place it
      // becomes the modelled shape the rest of casemedia reads.
      details: tdo.details as AssetFileType['details'],
      createdDateTime: tdo.createdDateTime,
      modifiedDateTime: tdo.modifiedDateTime,
      startDateTime: tdo.startDateTime,
      stopDateTime: tdo.stopDateTime,
      status: tdo.status,
      // Existence, not identity — the filter only ever asks whether there is
      // one, and the query selects a single id to answer exactly that.
      hasRedactedOutput: !!tdo.redactedMediaAssets?.records?.some(
        (a) => !!a?.id
      ),
    }));

/**
 * VE-32420: the per-row columns for a window of ids — the rows the list is
 * about to draw.
 *
 * Failures are deliberately quiet. The row is already on screen carrying
 * everything the roster knows; what this adds is a thumbnail and a processing
 * dot. A snackbar for a column that did not arrive would be louder than the
 * thing it reports, and the next scroll past those rows asks again.
 */
export const fetchCaseFileRows =
  ({ caseId, tdoIds }: { caseId: CaseId; tdoIds: TDOId[] }) =>
  async (dispatch: Dispatch, getState: () => any) => {
    if (!tdoIds.length) {
      return;
    }
    try {
      const result = await callGraphQLApi<FetchCaseFileRowsByIdsQueryResponse>({
        actionTypes: [NOOP, NOOP, NOOP],
        query: fetchCaseFileRowsByIdsQuery,
        variables: { ids: tdoIds, limit: tdoIds.length },
        dispatch,
        getState,
        returnPartialDataOnNotFound: true,
      });
      const rows = result?.temporalDataObjects?.records;
      if (rows?.length) {
        dispatch(MERGE_CASE_FILE_ROWS({ caseId, rows }));
      }
    } catch {
      console.warn('[casemedia] could not load row details for a window', {
        count: tdoIds.length,
      });
    }
  };

/**
 * VE-30449: page through every file in a request and record the names for the
 * upload duplicate-name check.
 *
 * ADVANCES BY WHAT CAME BACK, NOT BY WHAT WAS ASKED FOR, and only an EMPTY
 * page ends it. The obvious version — `offset = pageIndex * PAGE_SIZE`, stop
 * on a page shorter than `PAGE_SIZE` — is correct only while the server
 * honours the limit it was given. A server that caps `childTDOs` below 1000
 * (its declared default is 30) would make page one look like the last page,
 * and the read would report `ready` holding a fraction of the request: not an
 * error the picker can fall back from, but a confident wrong answer that lets
 * real duplicates through. `TDOList.count` cannot rescue that — the schema
 * defines it as the records in THAT response, not a total, and reading it as
 * one already caused a regression here once (VE-30449 review B1). So the
 * position is tracked from the records actually received, which costs one
 * extra request at the end and is correct whatever the server does with the
 * limit. The TDO-lock scan in this file pages the same way, for the same
 * reason.
 *
 * Each page's names are published as they arrive (`APPEND_REQUEST_ROSTER`),
 * so a picker that stops waiting part-way still checks against everything read
 * so far.
 *
 * `ready` only once an empty page has been seen. Anything else — a failed
 * page, a `not_found` (which `callGraphQLApi` answers with `undefined` rather
 * than a throw), or the page cap — is `error`, carrying the names read so far.
 *
 * A read stops between pages once it is no longer the request's latest (the
 * dialog was reopened or closed), so abandoned reads do not pile up.
 *
 * Failures are logged as a fixed reason, never the raw error: a GraphQL error
 * carries the server's own messages, and console output reaches Sentry.
 */
export const fetchRequestRoster =
  ({ caseId, requestId }: { caseId: CaseId; requestId: string }) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const isCurrent = () =>
      selectRequestRoster(caseId)(getState())?.requestId === requestId;
    const entries: RequestRosterEntry[] = [];
    const seenIds = new Set<string>();
    let offset = 0;
    const fail = (reason: 'page_cap' | 'missing_result' | 'request_failed') => {
      console.warn(
        '[casemedia] could not load request file names for the duplicate check',
        { caseId, reason }
      );
      dispatch(
        SET_REQUEST_ROSTER({ caseId, requestId, status: 'error', entries })
      );
    };
    try {
      for (let pageIndex = 0; ; pageIndex++) {
        if (!isCurrent()) {
          return;
        }
        if (pageIndex === REQUEST_ROSTER_MAX_PAGES) {
          return fail('page_cap');
        }
        const result = await callGraphQLApi<FetchRequestRosterQueryResponse>({
          actionTypes: [NOOP, NOOP, NOOP],
          query: fetchRequestRosterQuery,
          variables: {
            caseId,
            limit: REQUEST_ROSTER_PAGE_SIZE,
            offset,
          },
          dispatch,
          getState,
          returnPartialDataOnNotFound: true,
        });
        const records = result?.folder?.childTDOs?.records;
        if (!records) {
          return fail('missing_result');
        }
        if (records.length === 0) {
          break;
        }
        offset += records.length;
        // Dedupe across pages: without a deterministic server order the same
        // TDO can arrive on more than one page (see REQUEST_ROSTER_PAGE_SIZE).
        // First wins — the entries are identical, so which copy is kept does
        // not matter, only that the roster does not double-count.
        const pageEntries = rosterEntriesFrom(records).filter(
          (entry) => !seenIds.has(entry.id)
        );
        pageEntries.forEach((entry) => seenIds.add(entry.id));
        entries.push(...pageEntries);
        if (pageEntries.length) {
          dispatch(
            APPEND_REQUEST_ROSTER({ caseId, requestId, entries: pageEntries })
          );
        }
      }
      dispatch(
        SET_REQUEST_ROSTER({ caseId, requestId, status: 'ready', entries })
      );
    } catch {
      fail('request_failed');
    }
  };

// VE-26016: delete order is deliberate. The case FOLDER (which carries the
// content-template link) is deleted first; the case SDO is purged only AFTER
// DELETE_FOLDER_SUCCESS, by the deleteCaseSdoRequest saga. The previous order
// deleted the SDO first, so any interrupted delete (folder delete then fails, is
// blocked as a non-empty folder, or the tab closes) left the case pointing at a
// deleted SDO — a dangling reference that breaks the folder-view fetch
// ("Failed to fetch folders"). Removing the link first means a failure leaves at
// most a harmless orphaned SDO, never a dangling link. Mirrors the trash-side
// ordering fix (VE-25907).
/**
 * Ask the trash module to purge the per-TDO side data of files a folder/case
 * delete just removed (VE-28551).
 *
 * Takes the MUTATION RESPONSE rather than the requested ids: the batch is an
 * aliased `deleteTDO` per file, each echoing its own `{ id }`, and a partial
 * response is the normal case rather than an edge one — callGraphQLApi returns
 * `undefined` for a batch containing any `not_found`, and returns only the
 * aliases that resolved otherwise. Anything the server did not confirm deleted
 * keeps its side data; a stranded row is recoverable, a file whose provenance
 * was erased under it is not.
 */
const purgeSideDataForDeletedTdos = (
  dispatch: Dispatch,
  response: unknown
): void => {
  if (!response || typeof response !== 'object') {
    return;
  }
  const deleted = Object.values(response as Record<string, unknown>)
    .map((entry) =>
      entry && typeof entry === 'object'
        ? (entry as { id?: unknown }).id
        : undefined
    )
    .filter((id): id is string => typeof id === 'string' && id.length > 0);
  if (deleted.length === 0) {
    return;
  }
  // Registered, not just dispatched: the watcher purges only ids it can claim
  // from here, so the action cannot be forged against a file nobody deleted.
  // See trash/pendingPurge.
  markTdosPurgeable(deleted);
  dispatch(actionPurgeTdoSideData({ tdoIds: deleted as unknown as TDOId[] }));
};

export const deleteCaseSdo =
  (payload: ActionDeleteCaseSdoPayload) => (dispatch: Dispatch) => {
    const { isCase } = payload;
    dispatch(DELETE_FOLDER_REQUEST({ ...payload, isCase }));
    // callIfFolderCaseIsUnlocked awaits this thunk; return a settled promise so
    // it matches the awaited-thunk contract without a needless async wrapper.
    return Promise.resolve();
  };

// Best-effort purge of a case's now-orphaned SDO, run only once its folder has
// been deleted (see deleteCaseSdoRequest saga). A failure here leaves a harmless
// orphaned SDO — nothing references it — so it must not surface as a user-facing
// error or block anything.
export const purgeCaseSdo =
  ({ sdoId }: Pick<ActionDeleteCaseSdoPayload, 'sdoId'>) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const schemaId = await lookupLatestCaseSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    try {
      await callGraphQLApi<DeleteSdoQueryResponse>({
        actionTypes: [NOOP, NOOP, NOOP],
        query: deleteSdoQuery,
        variables: { sdoId, schemaId },
        dispatch,
        getState,
        throwOnError: true,
      });
    } catch (err) {
      if (isObjectWithProperty(err, 'message')) {
        console.log(err.message);
      }
    }
  };

export const softDeleteCaseSdo =
  (payload: ActionSoftDeleteCaseSdoPayload, trashFolderId: string) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const schemaId = await lookupLatestCaseSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    const { sdoId, data, treeObjectId, folderId } = payload;
    try {
      const response = await callGraphQLApi<SoftDeleteSdoQueryResponse>({
        actionTypes: [NOOP, NOOP, NOOP],
        query: softDeleteSdoQuery,
        variables: { sdoId, schemaId, data },
        dispatch,
        getState,
        throwOnError: true,
      });

      if (response) {
        // VE-21114: the caller normalises oldFolderPath to the v1 (self-inclusive)
        // shape via tdoFolderChain, so the parent is always the second-to-last
        // node in both v1 and v2.
        const oldParentId = data.oldFolderPath?.at(-2)?.id;
        dispatch(
          actionMoveFolderRequest({
            treeObjectId,
            oldParentTreeId: oldParentId as FolderId,
            newParentTreeId: trashFolderId as FolderId,
            // VE-21114: v2 moveFolder authorizes by folder ids.
            folderId,
            oldParentId: oldParentId as FolderId,
            newParentId: trashFolderId as FolderId,
            isRoot: false,
            suppressSnackbar: true,
          })
        );
        dispatch(
          SOFT_DELETE_FOLDER_SUCCESS({
            id: treeObjectId,
            folderName: data.caseName,
          })
        );
      }
    } catch (err) {
      if (isObjectWithProperty(err, 'message')) {
        console.log(err.message);
      }
      dispatch(
        SOFT_DELETE_FOLDER_FAILURE({
          id: treeObjectId,
          folderName: data.caseName,
        })
      );
    }
  };

export const createNewFolder =
  ({
    newFolderName,
    parentId,
    isCase,
    isRoot,
    parentIsCase,
  }: {
    newFolderName: string;
    parentId: FolderId;
    isCase: boolean;
    isRoot: boolean;
    // The PARENT container's type, passed through untouched to the success
    // action so the post-create refetch can pick the right query.
    parentIsCase: boolean;
  }) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const schemaId = await lookupLatestCaseSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    const currentTime = new Date().toISOString();
    // VE-21114: v2 authorizes createFolderContentTemplate via OLP against the
    // folder's `id`; the deprecated `treeObjectId` no longer resolves there and
    // the link fails with not_allowed (folder+SDO already created → the request
    // appears but is unlinked). Link by `id` under v2 (v1 still uses treeObjectId).
    const isV2Folders = selectV2FoldersEnabled(getState());

    try {
      /* Create the folder object */
      const { createFolder: newFolder } =
        await callGraphQLApi<CreateNewFolderQueryResponse>({
          actionTypes: [NOOP, NOOP, CREATE_NEW_FOLDER_FAILURE],
          query: createNewFolderQuery,
          variables: {
            parentId,
            newFolderName,
          },
          dispatch,
          getState,
          throwOnError: true,
        });

      if (isCase) {
        /* Create the case sdo */
        const {
          createStructuredData: { id: newSdoId },
        } = await callGraphQLApi<CreateNewFolderSdoQueryResponse>({
          actionTypes: [NOOP, NOOP, CREATE_NEW_FOLDER_FAILURE],
          query: createNewFolderSdoQuery,
          variables: {
            newFolderName,
            folderTreeObjectId: newFolder.treeObjectId,
            currentTime,
            schemaId: schemaId,
          },
          dispatch,
          getState,
          throwOnError: true,
        });

        /* Link the folder and the case sdo together */
        await callGraphQLApi({
          actionTypes: [
            LINK_FOLDER_AND_CASE_SDO,
            LINK_FOLDER_AND_CASE_SDO_SUCCESS,
            CREATE_NEW_FOLDER_FAILURE,
          ],
          query: createNewFolderLinkQuery,
          variables: {
            schemaId,
            folderId: resolveFolderMutationId(isV2Folders, {
              folderId: newFolder.id,
              treeObjectId: newFolder.treeObjectId,
            }),
            sdoId: newSdoId,
          },
          dispatch,
          getState,
          throwOnError: true,
        });
      }

      await new Promise<void>((resolve) => {
        setTimeout(() => {
          resolve();
        }, DATABASE_UPDATE_DELAY);
      });

      dispatch(
        CREATE_NEW_FOLDER_SUCCESS({
          newFolderName,
          parentId,
          isRoot,
          parentIsCase,
        })
      );
    } catch (err) {
      if (isObjectWithStringProperty(err, 'message')) {
        console.log(err.message);
      }
      dispatch(CREATE_NEW_FOLDER_FAILURE({ newFolderName }, undefined));
    }
  };

type FileSearchQueryOperator = 'wildcard' | 'query_string' | 'terms';

type FileSearchQueryCondition =
  | {
      field: string;
      operator: FileSearchQueryOperator;
      value: string;
    }
  | {
      field: string;
      operator: FileSearchQueryOperator;
      values: string[];
    }
  | {
      operator: 'or';
      conditions: FileSearchQueryCondition[];
    };

/**
 * Elasticsearch field the literal (wildcard) filename search matches against.
 *
 * `veritone-file.filename.sort` is a `keyword` field with a lowercase
 * normalizer — the whole filename stored as one un-analyzed token. The bare
 * `veritone-file.filename` is an analyzed `text` field and is NOT
 * interchangeable with it; see buildFilenameWildcardPattern below.
 */
export const FILENAME_SEARCH_FIELD = 'veritone-file.filename.sort';

/**
 * Analyzed `text` field, searched alone for letters/digits-only terms and
 * alongside FILENAME_SEARCH_FIELD otherwise. Matches the search words as
 * separate words, in any order, which the literal wildcard cannot (with limits
 * on partial words — see buildFilenameSearchCondition).
 */
export const FILENAME_TOKEN_SEARCH_FIELD = 'veritone-file.filename';

/**
 * Build the `wildcard` pattern that matches a filename substring.
 *
 * This line has been flipped twice, each flip closing one ticket and re-opening
 * another. Read this before "simplifying" it:
 *
 *   VE-9076  (#3172) → `veritone-file.filename.sort`, so commas stopped
 *                      breaking matches. This caused VE-16448.
 *   VE-16448 (#3648) → back to `veritone-file.filename`. This caused VE-26800.
 *
 * Neither field is correct alone, because the field was never the whole
 * problem — the operator was:
 *
 *   - `veritone-file.filename` is analyzed `text`, and core-search-server
 *     special-cases that exact field name (operator-builder.elastic.js) to
 *     replace every non-word character — commas, parens, dots, spaces, and any
 *     backslash we escaped with — by a space, then ANDs the fragments. A pasted
 *     filename is shredded and matches nothing. That is VE-26800.
 *   - `.sort` fixes that, but the condition also used `query_string`, which
 *     splits its input on whitespace. On a keyword field an interior bare term
 *     means "the filename EQUALS this", so any query containing a space matched
 *     nothing. That is VE-16448.
 *
 * So: keyword field (no server-side rewrite) + `wildcard` operator (no
 * query_string parser, therefore no whitespace splitting). The only special
 * characters left are `*`, `?` and the escape character `\` itself, so those
 * are the only ones needing escaping — every other character, comma and
 * parenthesis included, matches literally.
 *
 * `\` must be escaped along with the wildcards, not omitted as "rare": a query
 * ENDING in a backslash would otherwise emit `*abc\*`, where the trailing `\*`
 * escapes our own closing wildcard and silently matches nothing.
 *
 * Whitespace runs collapse to `*` so spacing in a pasted filename need not match
 * exactly. On its own that makes word ORDER significant: `samuel sarabia` will
 * not match `…SARABIA,_SAMUEL…`. buildFilenameSearchCondition covers that case
 * by OR-ing this pattern with a token search on the analyzed field.
 *
 * Callers guard against empty input (fetchCasesFolderSearch returns early).
 */
export const buildFilenameWildcardPattern = (searchText: string): string => {
  const pattern = searchText
    .toLowerCase()
    .trim()
    // A `*`, `?` or `\` the user typed is a literal character, not syntax.
    // Escaping `\` first is why this is one character class, not two passes.
    .replace(/[\\*?]/g, '\\$&')
    .replace(/\s+/g, '*');
  return `*${pattern}*`;
};

/**
 * Build the `query_string` value for the analyzed FILENAME_TOKEN_SEARCH_FIELD,
 * or `null` when the search text has no letters or digits to search for.
 *
 * core-search-server replaces every character outside `[\w^*]` with a space
 * for this field anyway. Doing the same client-side (and dropping `^` and `*`,
 * which query_string would read as boost / wildcard syntax) lets us see when
 * nothing is left: a bare `**` there would match every file, and inside the OR
 * in buildFilenameSearchCondition that would swamp the literal match.
 */
export const buildFilenameTokenQuery = (searchText: string): string | null => {
  const words = searchText
    .toLowerCase()
    // Not `\W`: `_` is a regex word character but the analyzer splits on it,
    // so keeping it leaves `jane_doe` as one literal wildcard that matches
    // nothing the `.sort` branch doesn't already find.
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
  return words ? `*${words}*` : null;
};

const LETTERS_AND_DIGITS_ONLY = /^[a-z0-9]+$/i;

/**
 * The filename condition for the file search. Which field(s) we search depends
 * on the kind of term — agreed on PR #3927 / VE-26800. "both" is an OR: a file
 * matching EITHER field is returned, so the result is the union of the two.
 *
 *   Term type                      e.g.                .filename  .sort         Send
 *   1. Letters/digits only         report, a           match      match         .filename
 *   2. Multiple words (spaces)     jane doe            match      MISS if the   both
 *                                                                 order or
 *   3. Special chars, no spaces    jane_doe, doe,jane  match      separators    both
 *                                                                 differ
 *   4. Spaces + special chars      doe, jane (1)       some MISS  match         both
 *      (pasted filenames)
 *   5. Accented letters            café                too broad  match         both
 *   6. Only special chars          ()  .,-  _          skipped    match         .sort
 *
 *   1. Both fields find the same files at the same speed (the analyzed field
 *      keeps each whitespace chunk whole, so a term with no separator fits in
 *      one). `.filename` alone, because files indexed before `.sort` existed
 *      may have no `.sort` value, and the OR costs ~0.2–0.75s per search.
 *   2./3. `.sort` matches literally, so word order and separators must match
 *      the filename (VE-16448): `jane doe` finds `jane_doe.mp4` but not
 *      `DOE,_JANE.mp4`. `.filename` splits on punctuation and underscores and
 *      matches the words in any order, with one limit: query_string turns
 *      `*jane doe*` into `*jane` AND `doe*`, so the FIRST word only matches the
 *      end of a word, the LAST only the start of one, and middle words must be
 *      whole words. `jane doe` and `jane_doe` find `DOE,_JANE`; `sam sara`
 *      does not find `SARABIA,_SAMUEL` on either field. Wrapping every word in
 *      `*…*` would lift that, at the cost of one more leading-wildcard scan
 *      per word.
 *   4. The server shreds a pasted name on `.filename` into fragments that may
 *      match nothing (VE-26800). `.sort` matches it literally.
 *   5. The server treats non-ASCII letters as separators on `.filename`
 *      (`café` → `caf`), so that branch over-matches (`cafeteria`, `caffeine`).
 *      Because "both" is a union, those extra hits stay in the results — this
 *      over-matching is accepted, not prevented. Sending `.sort` alone would
 *      avoid it but lose any-order matching for accented multi-word names.
 *   6. Nothing is left to search on `.filename`, and an empty query there
 *      matches every file (see buildFilenameTokenQuery).
 */
export const buildFilenameSearchCondition = (
  searchText: string
): FileSearchQueryCondition => {
  const wildcardCondition: FileSearchQueryCondition = {
    field: FILENAME_SEARCH_FIELD,
    operator: 'wildcard',
    value: buildFilenameWildcardPattern(searchText),
  };
  const tokenQuery = buildFilenameTokenQuery(searchText);
  if (tokenQuery === null) {
    return wildcardCondition;
  }
  const tokenCondition: FileSearchQueryCondition = {
    field: FILENAME_TOKEN_SEARCH_FIELD,
    operator: 'query_string',
    value: tokenQuery,
  };
  if (LETTERS_AND_DIGITS_ONLY.test(searchText.trim())) {
    return tokenCondition;
  }
  return {
    operator: 'or',
    conditions: [wildcardCondition, tokenCondition],
  };
};

// The file search runs leading-wildcard queries that can take seconds. Only the
// newest request's results are ever rendered, so a new request aborts the one
// still in flight instead of letting it keep running. The saga's takeLatest
// does not do this: it `put`s this thunk, which then runs on its own.
let inFlightFileSearch: AbortController | null = null;

export const fetchCasesFolderSearch: Thunk<object> =
  () => async (dispatch, getState) => {
    // TODO: We need to type return of getState() properly
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const state = getState();
    const searchText: string = selectSearchText(state).trim();
    if (!searchText) {
      return;
    }
    const searchDefaultFolderLimit = selectSearchDefaultFolderLimit(state);
    const searchDefaultFileLimit = selectSearchDefaultFileLimit(state);
    const searchDefaultOffset = selectSearchDefaultOffset(state);
    const searchMoreFoldersOffset = selectSearchMoreFoldersOffset(state);
    const searchMoreFilesOffset = selectSearchMoreFilesOffset(state);
    const searchMoreFilesAvailable = selectSearchMoreFilesAvailable(state);
    const searchMoreFoldersAvailable = selectSearchMoreFoldersAvailable(state);
    const isSearchMoreResults = selectIsSearchMoreResults(state);
    const searchFoldersOffset =
      isSearchMoreResults && searchMoreFoldersAvailable
        ? searchDefaultFolderLimit + searchMoreFoldersOffset
        : searchDefaultOffset;
    const searchFilesOffset =
      isSearchMoreResults && searchMoreFilesAvailable
        ? searchDefaultFileLimit + searchMoreFilesOffset
        : searchDefaultOffset;
    const token =
      modules.auth.selectOAuthToken(state) ||
      modules.auth.selectSessionToken(state);
    const { apiRoot } = modules.config.getConfig(state);
    const searchNames = searchText.split(/[()\-\s]+/).filter(Boolean);
    const searchScopeFolderId = selectSearchScopeFolderId(state);
    const searchScopeTreeObjectId = selectSearchScopeTreeObjectId(state);
    const searchScopeIsCase = selectSearchScopeIsCase(state);
    const useGlobalSearch = selectSearchBarScopeMode(state) === 'everything';
    const capturedScopeMode = selectSearchBarScopeMode(state);
    const capturedScopeFolderId = selectSearchScopeFolderId(state);
    const capturedSearchText = searchText;

    const isStaleSearchRequest = () => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const latestState = getState();
      return (
        selectSearchText(latestState).trim() !== capturedSearchText ||
        selectSearchBarScopeMode(latestState) !== capturedScopeMode ||
        selectSearchScopeFolderId(latestState) !== capturedScopeFolderId
      );
    };

    try {
      let searchFoldersListPromise = null;
      if (
        !isSearchMoreResults ||
        (isSearchMoreResults && searchMoreFoldersAvailable)
      ) {
        if (!useGlobalSearch && searchScopeFolderId && !searchScopeIsCase) {
          searchFoldersListPromise =
            callGraphQLApi<SearchFolderByParentQueryResponse>({
              actionTypes: [SEARCH_CASES_AND_FOLDERS_INIT, NOOP, NOOP],
              query: searchFolderByParentQuery,
              variables: {
                folderId: searchScopeFolderId,
                limit: searchDefaultFolderLimit,
                offset: searchFoldersOffset,
                names: [...searchNames],
              },
              dispatch,
              getState,
              throwOnError: false,
              // Selects nested contentTemplates { sdo { data } }; tolerate a
              // dangling (deleted) SDO so one bad match can't drop the whole
              // folder search result (VE-26016).
              returnPartialDataOnNotFound: true,
            });
        } else if (useGlobalSearch || !searchScopeFolderId) {
          searchFoldersListPromise =
            callGraphQLApi<SearchFolderAndCasesQueryResponse>({
              actionTypes: [SEARCH_CASES_AND_FOLDERS_INIT, NOOP, NOOP],
              query: searchFolderAndCasesQuery,
              variables: {
                limit: searchDefaultFolderLimit,
                offset: searchFoldersOffset,
                names: [...searchNames],
              },
              dispatch,
              getState,
              throwOnError: false,
              // Selects nested contentTemplates { sdo { data } }; tolerate a
              // dangling (deleted) SDO so one bad match can't drop the whole
              // folder search result (VE-26016).
              returnPartialDataOnNotFound: true,
            });
        }
      }

      let searchFilesPromise = null;
      let fileSearchSignal: AbortSignal | null = null;
      if (
        !isSearchMoreResults ||
        (isSearchMoreResults && searchMoreFilesAvailable)
      ) {
        const fileSearchJson = {
          index: ['mine'],
          select: ['veritone-file'],
          limit: searchDefaultFileLimit,
          offset: searchFilesOffset,
          query: {
            operator: 'and',
            conditions: [] as FileSearchQueryCondition[],
          },
        };
        fileSearchJson.query.conditions.push(
          buildFilenameSearchCondition(searchText)
        );
        if (!useGlobalSearch && searchScopeTreeObjectId) {
          fileSearchJson.query.conditions.push({
            field: 'parentTreeObjectIds',
            operator: 'terms',
            values: [searchScopeTreeObjectId],
          });
        }
        dispatch(SEARCH_CASES_AND_FOLDERS_INIT(undefined));
        inFlightFileSearch?.abort();
        const fileSearchController = new AbortController();
        inFlightFileSearch = fileSearchController;
        fileSearchSignal = fileSearchController.signal;
        searchFilesPromise = fetch(
          `${apiRoot}/api/search/file_search_authtoken`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(fileSearchJson),
            signal: fileSearchSignal,
          }
        ).then((response) => {
          // A rejected query (bad request, expensive-query limits, 5xx) has an
          // error body with no `records`. Parsed as a result, it renders as
          // "No results" — the same symptom as VE-9076/16448/26800, so a
          // server failure would be indistinguishable from a missed match.
          if (!response.ok) {
            throw new Error(
              `File search failed: ${response.status} ${response.statusText}`
            );
          }
          return response.json() as Promise<FilesElasticSearchResult>;
        });
      }

      // VE-25873 Unit 1 — when the term is a 10-digit TDO ID, look the TDO up
      // globally (independent of scope) and merge it into results. Only on the
      // initial results set, never on "search more" paging (FR-1.1..FR-1.3).
      const isTdoIdSearch = !isSearchMoreResults && isTdoIdTerm(searchText);
      let tdoIdLookupPromise: Promise<
        TdosDetailsResponse | null | undefined
      > | null = null;
      if (isTdoIdSearch) {
        tdoIdLookupPromise = callGraphQLApi<TdosDetailsResponse>({
          actionTypes: [NOOP, NOOP, NOOP],
          query: getTdoDetailsQuery([searchText as TDOId], {
            includePrimaryAsset: true,
          }),
          variables: {},
          dispatch,
          getState,
          throwOnError: false,
          returnPartialDataOnNotFound: true,
        });
      }

      const [folderSettled, filesSettled, tdoIdSettled] =
        await Promise.allSettled([
          searchFoldersListPromise ?? Promise.resolve(null),
          searchFilesPromise ?? Promise.resolve(null),
          // The TDO-ID lookup must never fail the search — its rejection is
          // swallowed here so filename/folder results still render (NFR-1).
          tdoIdLookupPromise ?? Promise.resolve(null),
        ]);
      // Superseded by a newer search, which owns the in-progress state and the
      // results. isStaleSearchRequest can't tell: the newer search may use the
      // same text (e.g. Enter right after the debounce fired).
      if (fileSearchSignal?.aborted) {
        return;
      }
      // If a request actually errored (e.g. the file-search fetch rejected),
      // surface a failure instead of silently rendering an empty result set.
      if (
        folderSettled.status === 'rejected' ||
        filesSettled.status === 'rejected'
      ) {
        if (!isStaleSearchRequest()) {
          const reason: unknown =
            folderSettled.status === 'rejected'
              ? folderSettled.reason
              : filesSettled.status === 'rejected'
                ? filesSettled.reason
                : undefined;
          dispatch(
            SEARCH_CASES_AND_FOLDERS_FAILURE(
              isObjectWithStringProperty(reason, 'message')
                ? reason.message
                : undefined
            )
          );
        }
        return;
      }

      const searchedFolderList =
        folderSettled.status === 'fulfilled' ? folderSettled.value : null;
      const filesResults =
        filesSettled.status === 'fulfilled' ? filesSettled.value : null;

      let allTdosDetailsResponse = null;
      const filteredTdos: Array<TdoDetail> = [];
      const tdosWithFilePath = new Map<TDOId, TdoSearchDetail>();
      // TDOs living under the REDACT TRASH folder — excluded from results so
      // trashed files don't show up in search (matches Drive/Gmail behavior).
      const trashedTdoIds = new Set<string>();
      if (filesResults?.records && arrayHasContents(filesResults.records)) {
        // TODO: Is it correct to assume that mediaId -> string is a TODId?
        const allTdoIds: TDOId[] = filesResults.records.map(
          (f) => `${f.mediaId}`
        );
        const batchSize = 30;
        const batchFilePathCall = async (batchTdoIds: TDOId[]) => {
          if (arrayHasContents(batchTdoIds)) {
            const query = getTdoDetailsQuery(batchTdoIds);
            allTdosDetailsResponse = await callGraphQLApi<TdosDetailsResponse>({
              actionTypes: [NOOP, NOOP, NOOP],
              query,
              variables: {},
              dispatch,
              getState,
              throwOnError: false,
              returnPartialDataOnNotFound: true,
            });

            if (allTdosDetailsResponse) {
              for (const tdo of Object.values(allTdosDetailsResponse)) {
                if (!tdo?.id) {
                  continue;
                }
                // Drop trashed TDOs: don't record their path and remember the
                // id so their file-search record is filtered out below.
                if (tdo.folders?.some(isFolderUnderTrash)) {
                  trashedTdoIds.add(`${tdo.id}`);
                  continue;
                }
                if (tdo.folders?.length > 0) {
                  filteredTdos.push(tdo);
                }
                const folder = tdo.folders?.[0];
                const filePath = folder
                  ? concatenateNamesWithForwardSlash(folder)
                  : '';
                const status = getRedactionStatusFromTdo(tdo);
                const existing = tdosWithFilePath.get(tdo.id);
                tdosWithFilePath.set(tdo.id, {
                  filePath: filePath || existing?.filePath || '',
                  redactionStatus:
                    status?.redactionStatus ?? existing?.redactionStatus,
                  redactionStatusName:
                    status?.redactionStatusName ??
                    existing?.redactionStatusName,
                  // VE-25873 Unit 2 — immediate parent folder/request, so the
                  // result's breadcrumb can open it instead of the file.
                  parentFolderId: folder?.id ?? existing?.parentFolderId,
                  parentIsCase: Boolean(
                    (folder?.contentTemplates?.length ?? 0) > 0 ||
                      existing?.parentIsCase
                  ),
                });
              }
            }
          }
        };

        const numBatches = Math.ceil(allTdoIds.length / batchSize);
        for (let i = 0; i < numBatches; i++) {
          const startIndex = i * batchSize;
          const endIndex = startIndex + batchSize;
          const batchTdoIds = allTdoIds.slice(startIndex, endIndex);
          await batchFilePathCall(batchTdoIds);
        }

        if (!useGlobalSearch && searchScopeFolderId) {
          const scopedIds = new Set(
            filteredTdos
              .filter((tdo) =>
                isTdoWithinFolder(tdo, searchScopeFolderId as string)
              )
              .map((tdo) => tdo.id)
          );
          for (const tdoId of [...tdosWithFilePath.keys()]) {
            if (!scopedIds.has(tdoId)) {
              tdosWithFilePath.delete(tdoId);
            }
          }
        }
      }

      const scopedPathPrefix =
        !useGlobalSearch && searchScopeFolderId
          ? buildScopedPathPrefix(state)
          : undefined;

      const rawFolderRecords =
        !useGlobalSearch && searchScopeFolderId && !searchScopeIsCase
          ? ((searchedFolderList as SearchFolderByParentQueryResponse | null)
              ?.folder?.childFolders?.records ?? [])
          : useGlobalSearch || !searchScopeFolderId
            ? (pickRootAdminFolder(
                (searchedFolderList as SearchFolderAndCasesQueryResponse | null)
                  ?.rootFolders,
                selectRootFolderSmartSelection(state)
              )?.childFolders?.records ?? [])
            : [];
      const childFolders = rawFolderRecords.filter(
        ({ id, name, contentTemplates }) =>
          (useGlobalSearch ||
            !searchScopeFolderId ||
            id !== searchScopeFolderId) &&
          // Never surface the REDACT TRASH system folder in search results.
          name !== SYSTEM_FOLDER_REDACT_TRASH &&
          // Exclude requests/folders that have been moved to trash. A trashed
          // request can still be linked in the normal folder tree, so detect it
          // by the movedToTrashDateTime on its content-template SDO rather than
          // by parent folder. Check every template — a trashed folder may carry
          // more than one SDO and the trash one isn't necessarily first.
          !contentTemplates?.some(
            (ct) => ct?.sdo?.data?.movedToTrashDateTime
          ) &&
          searchNames.every((searchName) =>
            name?.toLowerCase().includes(searchName.toLowerCase())
          )
      );
      const foldersResults = {
        results: mapSearchFolderResults(
          childFolders as SearchFolderRecord[],
          scopedPathPrefix
        ),
        rawCount: rawFolderRecords.length,
        from: searchFoldersOffset,
        searchToken: token,
        totalResults: childFolders.length,
      };

      const scopedFilesResults =
        !useGlobalSearch && searchScopeFolderId && filesResults?.records
          ? {
              ...filesResults,
              records: filesResults.records.filter((r) =>
                tdosWithFilePath.has(`${r.mediaId}`)
              ),
            }
          : filesResults;

      // Exclude files that live in the REDACT TRASH folder from the results
      // (covers global search; scoped search already drops them via the
      // tdosWithFilePath filter above, since trashed TDOs aren't recorded).
      const visibleFileRecords = (scopedFilesResults?.records || []).filter(
        (r) => !trashedTdoIds.has(`${r.mediaId}`)
      );

      const apiSearchMoreFilesAvailable =
        (filesResults?.records?.length ?? 0) === searchDefaultFileLimit;

      // The abort check again: a same-text search may have superseded this one
      // while it awaited the TDO-details batches above.
      if (isStaleSearchRequest() || fileSearchSignal?.aborted) {
        return;
      }

      // VE-25873 Unit 1 — build the TDO-ID match (accessible, non-Trash only)
      // so it can be prepended ahead of all other results (FR-1.3..FR-1.5).
      const tdoIdResult: SearchResultFile | null = (() => {
        if (!isTdoIdSearch) {
          return null;
        }
        const resp =
          tdoIdSettled.status === 'fulfilled' ? tdoIdSettled.value : null;
        const tdo = resp ? Object.values(resp).find((t) => t?.id) : undefined;
        if (!tdo || tdo.folders?.some(isFolderUnderTrash)) {
          return null;
        }
        // VE-25873 — the TDO-ID lookup honors the scope toggle: when scoped to
        // a folder/request, only surface the TDO if it lives within that scope
        // (global only under "Everything"). Reversal of the original Q2=A.
        if (
          !useGlobalSearch &&
          searchScopeFolderId &&
          !isTdoWithinFolder(tdo, searchScopeFolderId as string)
        ) {
          return null;
        }
        const folder = tdo.folders?.[0];
        return {
          mediaId: Number(tdo.id),
          filename: tdo.name ?? `${tdo.id}`,
          createdDateTime: '',
          fullFilePath: folder ? concatenateNamesWithForwardSlash(folder) : '',
          redactionStatus: getRedactionStatusFromTdo(tdo)?.redactionStatus,
          redactionStatusName:
            getRedactionStatusFromTdo(tdo)?.redactionStatusName,
          parentFolderId: folder?.id as FolderId | undefined,
          parentIsCase: Boolean((folder?.contentTemplates?.length ?? 0) > 0),
          // Without the mimetype, PDFs matched by TDO ID open in the media
          // editor instead of the document editor — and the de-dupe below
          // drops the filename record that would otherwise carry it.
          // Resolve through the shared helper (primaryAsset.contentType →
          // veritoneFile mimetype/mimeType/fileType) rather than reading one
          // or two fields directly: primaryAsset(media) is null on some TDOs
          // and details' veritoneFile carries the MIME under a different key
          // depending on the ingestion path.
          mimetype: resolveFileType({
            primaryAsset: tdo.primaryAsset,
            details: parseTdoDetails(tdo.details),
          }),
          fileId: Number(tdo.id),
          matchedByTdoId: true,
        };
      })();

      const previousSearchResults = selectSearchResults(state);
      dispatch(
        actionSetSearchResults({
          searchResults: [
            ...(isSearchMoreResults ? previousSearchResults || [] : []),
            // TDO-ID match first (FR-1.3).
            ...(tdoIdResult ? [tdoIdResult] : []),
            ...(foldersResults?.results || []),
            // De-dupe: drop the filename record for the same TDO so it isn't
            // listed twice alongside the TDO-ID match.
            ...visibleFileRecords
              .filter(
                (currentRecord) =>
                  !tdoIdResult || currentRecord.mediaId !== tdoIdResult.mediaId
              )
              .map((currentRecord) => ({
                filename: currentRecord.metadata['veritone-file'].filename,
                mediaId: currentRecord.mediaId,
                createdDateTime: currentRecord.createdTime,
                fullFilePath:
                  tdosWithFilePath.get(`${currentRecord.mediaId}`)?.filePath ??
                  '',
                mimetype: currentRecord.metadata['veritone-file'].mimetype,
                redactionStatus: tdosWithFilePath.get(
                  `${currentRecord.mediaId}`
                )?.redactionStatus,
                redactionStatusName: tdosWithFilePath.get(
                  `${currentRecord.mediaId}`
                )?.redactionStatusName,
                // VE-25873 Unit 2 — parent folder/request for breadcrumb navigation.
                parentFolderId: tdosWithFilePath.get(`${currentRecord.mediaId}`)
                  ?.parentFolderId as FolderId | undefined,
                parentIsCase: tdosWithFilePath.get(`${currentRecord.mediaId}`)
                  ?.parentIsCase,
              })),
          ],
          searchMoreFilesOffset: searchFilesOffset,
          searchMoreFoldersOffset: searchFoldersOffset,
          searchMoreFilesAvailable: apiSearchMoreFilesAvailable,
          searchMoreFoldersAvailable:
            foldersResults?.rawCount === searchDefaultFolderLimit,
          cacheKey: buildSearchCacheKey(
            searchText,
            capturedScopeMode,
            capturedScopeFolderId
          ),
        })
      );
    } catch (err) {
      dispatch(
        SEARCH_CASES_AND_FOLDERS_FAILURE(
          isObjectWithStringProperty(err, 'message') ? err.message : undefined
        )
      );
    }
  };

// VE-25873 Unit 3 — resolve a TDO's owning case/folder (its "parent request").
// The editor's `caseId` IS a folder id (fetchCaseMedia queries
// `folder(id: caseId).childTDOs`), so the answer is one of the TDO's non-Trash
// parent folders; a folder carrying content templates is a case/request. When
// the URL already names a case, `preferFolderId` picks that parent when the
// TDO indeed lives under it (falling back to the first non-Trash parent when
// it doesn't — e.g. a stale link after the file was moved).
// Returns null when there is no accessible owning folder — and on ANY lookup
// error, so a failed lookup can never block the editor from opening (FR-3.5,
// NFR-1).
export const fetchTdoOwningCase: Thunk<
  { tdoId: TDOId; preferFolderId?: string },
  { caseId: FolderId; isCase: boolean } | null
> =
  ({ tdoId, preferFolderId }) =>
  async (dispatch, getState) => {
    try {
      const resp = await callGraphQLApi<TdosDetailsResponse>({
        actionTypes: [NOOP, NOOP, NOOP],
        query: getTdoDetailsQuery([tdoId]),
        variables: {},
        dispatch,
        getState,
        throwOnError: false,
        returnPartialDataOnNotFound: true,
      });
      const tdo = resp ? Object.values(resp).find((t) => t?.id) : undefined;
      const parents = (tdo?.folders ?? []).filter(
        (f) => f?.id && !isFolderUnderTrash(f)
      );
      const owningFolder =
        (preferFolderId && parents.find((f) => f.id === preferFolderId)) ||
        parents[0];
      if (!owningFolder?.id) {
        return null;
      }
      return {
        caseId: owningFolder.id as FolderId,
        isCase: (owningFolder.contentTemplates?.length ?? 0) > 0,
      };
    } catch {
      return null;
    }
  };

function concatenateNamesWithForwardSlash(folder: Folder): string {
  if (!folder.parent) {
    return '';
  }
  if (!folder.parent.parent) {
    return folder.name;
  }
  const parentPath = concatenateNamesWithForwardSlash(folder.parent);
  return parentPath ? `${parentPath}/${folder.name}` : folder.name;
}

// VE-25873 Unit 1 — a search term is treated as a candidate TDO ID when it is
// exactly a 10-digit number (see FR-1.1). Exported for unit tests.
export const isTdoIdTerm = (term: string): boolean =>
  /^\d{10}$/.test(term.trim());

// True when the TDO lives under the given folder id (directly or via any
// ancestor). Used to keep scoped search — including the VE-25873 TDO-ID
// lookup — limited to the currently-selected folder/request.
function isTdoWithinFolder(tdo: TdoDetail, scopeId: string): boolean {
  const checkFolder = (folder: Folder | undefined): boolean => {
    if (!folder) {
      return false;
    }
    if (folder.id === scopeId) {
      return true;
    }
    return checkFolder(folder.parent);
  };
  return tdo.folders.some((f) => checkFolder(f));
}

// A folder is "in trash" if it or any ancestor is the REDACT TRASH system
// folder. Used to keep trashed items out of search results.
function isFolderUnderTrash(folder: Folder | undefined): boolean {
  if (!folder) {
    return false;
  }
  if (folder.name === SYSTEM_FOLDER_REDACT_TRASH) {
    return true;
  }
  return isFolderUnderTrash(folder.parent);
}

function pickRootAdminFolder(
  rootFolders: SearchFolderAndCasesQueryResponse['rootFolders'] | undefined,
  smartSelection?: boolean
) {
  return selectAdminRootFolder(rootFolders, { smartSelection }) ?? null;
}

interface ParsedTdoDetails {
  tags?: unknown;
  // The MIME can live under any of these keys depending on the ingestion
  // path — resolveFileType checks them in order.
  veritoneFile?: { mimetype?: string; mimeType?: string; fileType?: string };
}

function parseTdoDetails(details: unknown): ParsedTdoDetails | null {
  if (typeof details === 'string') {
    try {
      return JSON.parse(details) as ParsedTdoDetails;
    } catch {
      return null;
    }
  }
  if (details && typeof details === 'object') {
    return details as ParsedTdoDetails;
  }
  return null;
}

function getRedactionStatusFromTdo(
  tdo: TdoDetail
): { redactionStatus: string; redactionStatusName: string } | undefined {
  const parsed = parseTdoDetails(tdo.details);
  if (!parsed || !isObjectWithProperty(parsed, 'tags')) {
    return undefined;
  }
  const rawTags: unknown = parsed.tags;
  if (!Array.isArray(rawTags)) {
    return undefined;
  }
  for (const tag of rawTags) {
    if (
      isObjectWithProperty(tag, 'value') &&
      tag.value === IN_REDACTION_TAG_KEY &&
      isObjectWithStringProperty(tag, 'redactionStatus')
    ) {
      // Identity = key when present (custom), else the stored name; keep the
      // frozen name for orphan display (VE-24546).
      const identity = getRedactionStatusIdentity(tag) ?? tag.redactionStatus;
      return {
        redactionStatus: identity,
        redactionStatusName: tag.redactionStatus,
      };
    }
  }
  return undefined;
}

function buildScopedPathPrefix(state: { [key: string]: unknown }): string[] {
  const selectedFolders = selectSelectedFolders(
    state as Parameters<typeof selectSelectedFolders>[0]
  );
  const parts: string[] = [];
  selectedFolders.forEach((folder) => {
    if (folder.name) {
      parts.push(folder.name);
    }
  });
  return parts;
}

function buildSearchFolderBreadcrumb(
  folderPath: FolderPathItem[] | undefined,
  folderName: string,
  scopedPathPrefix?: string[]
): string {
  if (folderPath?.length) {
    const sorted = sortFolderPath(folderPath);
    const names = sorted.map((folder) => folder.name).filter(Boolean);
    const pathWithoutRoot = names.length > 1 ? names.slice(1) : names;
    if (
      !pathWithoutRoot.length ||
      pathWithoutRoot[pathWithoutRoot.length - 1] !== folderName
    ) {
      pathWithoutRoot.push(folderName);
    }
    return pathWithoutRoot.join(' > ');
  }
  if (scopedPathPrefix?.length) {
    return [...scopedPathPrefix, folderName].join(' > ');
  }
  return folderName;
}

interface SearchFolderRecord {
  id?: string;
  name?: string;
  createdDateTime?: string;
  contentTemplates?: FolderStateType['contentTemplates'];
}

const mapSearchFolderResults = (
  childFolders: SearchFolderRecord[] | undefined,
  scopedPathPrefix?: string[]
) => {
  const folderList = (childFolders || [])
    .map(
      ({ id: folderTreeObjectId, name, createdDateTime, contentTemplates }) => {
        if (!name || !createdDateTime || !folderTreeObjectId) {
          return null;
        }
        return {
          caseName: name,
          createdDateTime,
          folderTreeObjectId: folderTreeObjectId as FolderId,
          contentTemplates,
          fullFolderPath: buildSearchFolderBreadcrumb(
            undefined,
            name,
            scopedPathPrefix
          ),
        };
      }
    )
    .filter((folder) => !!folder);
  return folderList || [];
};

export const fetchLegacyMedias =
  (payload: ActionFetchLegacyMediasRequest) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const schemaId = await lookupLatestSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    return await callGraphQLApi<FetchLegacyMediasQueryResponse>({
      actionTypes: [
        FETCH_LEGACY_MEDIAS_INIT,
        FETCH_LEGACY_MEDIAS_SUCCESS,
        FETCH_LEGACY_MEDIAS_FAILURE,
      ],
      query: fetchLegacyMediasQuery,
      // The sort is the SERVER's ordering, not a client pass — see
      // `unassignedSortOrderBy`. Read from state rather than taken per call:
      // every page of one read has to use the SAME ordering, and this list is
      // paged from five different places. Passing it would mean five chances
      // to forget, and the failure is silent — pages that are slices of
      // different orderings, interleaved with no error anywhere.
      variables: {
        schemaId,
        limit: payload.limit,
        offset: payload.offset,
        orderBy: [unassignedSortOrderBy(selectUnassignedSort(getState()))],
      },
      dispatch,
      getState,
    });
  };

export interface ActionSoftDeleteFolderPayload {
  folderId: FolderId;
  folderName: string;
  treeObjectId: TreeObjectId;
  trashRetentionDays: number;
  oldFolderPath: FolderPathItem[];
  movedToTrashByName: string;
  movedToTrashById: string;
}

export const softDeleteFolder =
  (payload: ActionSoftDeleteFolderPayload, trashFolderId: string) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const schemaId = await lookupLatestCaseSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    const {
      treeObjectId,
      folderId,
      folderName,
      trashRetentionDays,
      oldFolderPath,
      movedToTrashByName,
      movedToTrashById,
    } = payload;
    try {
      const { enableDeleteNonEmptyFolder } = selectFeatureFlags(getState());
      // VE-21114: v2 authorizes createFolderContentTemplate (the folder↔SDO
      // link) via OLP against the folder id; the deprecated treeObjectId returns
      // not_allowed. Reads still accept either, so swap the id under v2 only.
      const isV2Folders = selectV2FoldersEnabled(getState());

      if (!enableDeleteNonEmptyFolder) {
        const res = await callGraphQLApi<FetchSubFoldersQueryResponse>({
          actionTypes: [
            CHECK_EMPTY_FOLDER_REQUEST,
            CHECK_EMPTY_FOLDER_SUCCESS,
            CHECK_EMPTY_FOLDER_FAILURE,
          ],
          query: fetchSubFoldersQuery,
          variables: {
            folderId: treeObjectId,
            limit: 1,
            offset: 0,
          },
          dispatch,
          getState,
          throwOnError: false,
          // Selects nested contentTemplates { sdo { data } }; tolerate a
          // dangling (deleted) SDO so one bad child can't collapse this read to
          // undefined and make a non-empty folder look empty (VE-26016).
          returnPartialDataOnNotFound: true,
        });

        if (
          res?.folder?.childFolders?.count &&
          res.folder.childFolders.count > 0
        ) {
          dispatch(
            enqueueSnackbar({
              message: `Folder ${folderName} must be empty to delete!`,
              variant: 'error',
            })
          );
          return;
        }
      }

      const {
        createStructuredData: { id: newSdoId },
      } = await callGraphQLApi<CreateSoftDeletedSdoQueryResponse>({
        actionTypes: [DELETE_FOLDER_INIT, NOOP, NOOP],
        query: createSoftDeletedFolderSdoQuery,
        variables: {
          folderName,
          treeObjectId,
          currentTime: new Date().toISOString(),
          schemaId: schemaId,
          trashRetentionDays,
          oldFolderPath,
          movedToTrashByName,
          movedToTrashById,
        },
        dispatch,
        getState,
        throwOnError: true,
      });

      /* Link the folder and the case sdo together */
      const response = await callGraphQLApi({
        actionTypes: [
          LINK_FOLDER_AND_CASE_SDO,
          LINK_FOLDER_AND_CASE_SDO_SUCCESS,
          LINK_FOLDER_AND_CASE_SDO_FAILURE,
        ],
        query: createNewFolderLinkQuery,
        variables: {
          schemaId,
          folderId: resolveFolderMutationId(isV2Folders, {
            folderId,
            treeObjectId,
          }),
          sdoId: newSdoId,
        },
        dispatch,
        getState,
        throwOnError: true,
      });

      if (response) {
        // VE-21114: the caller normalises oldFolderPath to the v1 (self-inclusive)
        // shape via tdoFolderChain, so the parent is always the second-to-last
        // node in both v1 and v2.
        const oldParentId = oldFolderPath?.at(-2)?.id;
        dispatch(
          actionMoveFolderRequest({
            treeObjectId,
            oldParentTreeId: oldParentId as FolderId,
            newParentTreeId: trashFolderId as FolderId,
            // VE-21114: v2 moveFolder authorizes by folder ids.
            folderId,
            oldParentId: oldParentId as FolderId,
            newParentId: trashFolderId as FolderId,
            isRoot: false,
            suppressSnackbar: true,
          })
        );
        dispatch(SOFT_DELETE_FOLDER_SUCCESS({ id: treeObjectId, folderName }));
      }
    } catch (err) {
      console.error('failed to softDeleteFolder', err, payload);
      dispatch(SOFT_DELETE_FOLDER_FAILURE({ id: treeObjectId, folderName }));
    }
  };

export const deleteMediaFileSdo =
  (payload: ActionDeleteMediaFileSdoPayload) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const schemaId = await lookupLatestSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    const { sdoId, isSoftDelete, data } = payload;
    try {
      const deleteResponse = await callGraphQLApi<
        DeleteSdoQueryResponse | SoftDeleteSdoQueryResponse
      >({
        actionTypes: [NOOP, NOOP, DELETE_MEDIA_FILE_SDO_FAILURE],
        query: isSoftDelete ? softDeleteSdoQuery : deleteSdoQuery,
        variables: isSoftDelete
          ? { sdoId, schemaId, data }
          : { sdoId, schemaId },
        dispatch,
        getState,
        throwOnError: true,
      });

      if (deleteResponse) {
        dispatch(DELETE_MEDIA_FILE_SDO_SUCCESS(payload));
      }
    } catch (err) {
      console.error('failed to deleteMediaFileSdo', err, payload);
      dispatch(
        // @ts-expect-error TODO: Validate the type of err matches what's expected here
        DELETE_MEDIA_FILE_SDO_FAILURE([err], {
          variables: { tdoName: payload.tdoName },
        })
      );
    }
  };

export type FetchTdoDetailForSdosResponse = Record<
  string,
  {
    id: string;
    name: string;
    details: unknown;
    jobs: {
      records: {
        status: string;
      }[];
    };
    folders: {
      id: string;
      name: string;
    }[];
  }
>;

/**
 * VE-26943: aliases per request. The export flow settled on 20 for the same
 * shape of query; this selection set is heavier (five asset sub-selections per
 * TDO), so do not raise it without measuring.
 */
export const UNASSIGNED_TDO_DETAIL_BATCH_SIZE = 20;

export const fetchTdoDetailForSdos: Thunk<{
  tdoIds: TDOId[];
}> = (payload) => async (dispatch, getState) => {
  const { tdoIds } = payload;
  // VE-26943: this used to fetch name/details/jobs/folders only — enough for the
  // old panel's name + status rows, and the reason unassigned files could not
  // show a Redacted/Original badge, engine icons, duration or any download
  // option. It now pulls the full per-file selection set (see
  // getUnassignedTdoDetailsQuery), so a mapped row is a normal AssetFileType.
  const batches: TDOId[][] = [];
  for (
    let i = 0;
    i < (tdoIds || []).length;
    i += UNASSIGNED_TDO_DETAIL_BATCH_SIZE
  ) {
    batches.push(tdoIds.slice(i, i + UNASSIGNED_TDO_DETAIL_BATCH_SIZE));
  }

  // Each batch dispatches its own SUCCESS with a partial payload; the reducer
  // merges by tdoId and leaves rows it doesn't mention alone.
  const responses = await Promise.all(
    batches.map((batch) =>
      callGraphQLApi<FetchTdoDetailForSdosResponse>({
        actionTypes: [
          NOOP,
          FETCH_TDO_DETAIL_FOR_SDOS_SUCCESS,
          FETCH_TDO_DETAIL_FOR_SDOS_FAILURE,
        ],
        query: getUnassignedTdoDetailsQuery(batch),
        // VE-27388: the ids are ALIASES baked into the query text, so the
        // operation declares no variables and the server ignores these. They
        // are passed purely so callGraphQLApi puts them on the dispatched
        // action's `meta.variables`, which is the only way the reducer can
        // know WHICH batch just settled. Without them
        // markLegacyTdoDetailAttempted recorded nothing, isEnrichmentOutstanding
        // stayed true for every row forever, and isFetchingLegacyMedias never
        // cleared — a permanent spinner at the foot of the docked list.
        variables: { tdoIds: batch },
        dispatch,
        getState,
        // VE-26943: a TDO deleted out from under its SDO would otherwise fail
        // the whole batch, leaving every other file in it nameless.
        returnPartialDataOnNotFound: true,
      })
    )
  );
  return responses[0];
};

const getLockAuthorization = (getState: () => any) => {
  const oauthToken = selectOAuthToken(getState());
  const sessionToken = selectSessionToken(getState());
  const { apiRoot, graphQLEndpoint, veritoneAppId } =
    getConfig<Window['config']>(getState());
  return {
    endpoint: `${apiRoot}/${graphQLEndpoint}`,
    token: sessionToken || oauthToken,
    veritoneAppId,
  };
};

// A lock is live while its editor keeps refreshing `lastAccessed`; one older
// than five refresh periods belongs to an editor that closed or crashed.
//
// Imported rather than redefined: the copy that used to live here read a
// record with NO `lastAccessed` as fresh (`moment(undefined)` is now), which
// made a malformed record a lock that never expires. `projects/setLock`
// already had the null-safe version, and VE-32218 is consolidating these.

/**
 * What a lock read concluded.
 *
 * `unknown` is deliberately NOT `unlocked`. `fetchGraphQLApi` resolves
 * `{ errors, data: null }` rather than throwing (`helpers/callApi.ts`), so a
 * failed read is indistinguishable from "nobody holds a lock" unless the
 * caller looks — and reading it as unlocked reproduces VE-30856's symptom, the
 * delete going ahead, every time the lock query errors. The server-side guard
 * (`server/src/adapters/checkTdoIsLocked.ts`) already fails closed; this
 * matches it.
 */
type TdoLockState = 'unlocked' | 'lockedByOther' | 'unknown';

/**
 * A lock read, and whom it found.
 *
 * `heldBy` is the holder's display name as the EDITOR wrote it into the lock
 * record — `checkTdoLock` stores `${firstName} ${lastName}` alongside the
 * userId (`pages/MediaDetails`, `pages/DocumentDetails`). Reporting a holder
 * therefore costs no second query: it is the same denormalised field
 * `projects/setLock.ts` surfaces as `heldBy` for the merged-document gate.
 * Set only for `lockedByOther` — our own lock is not something to report —
 * and may still be absent, so callers fall back to "another user".
 */
interface TdoLockRead {
  state: TdoLockState;
  heldBy?: string;
}

/**
 * The holder's name, or undefined when the record does not really carry one.
 *
 * `checkTdoLock` builds the name by interpolation, so a lock taken before the
 * user kvp resolved is stored as the literal string "undefined undefined" (or
 * "undefined Smith"). Dropping those tokens turns a refusal that would read
 * "edited by undefined undefined" into the "another user" fallback.
 */
const lockHolderName = (name: string | undefined) => {
  const words = (name || '')
    .split(/\s+/)
    .filter((word) => word && word !== 'undefined');
  return words.join(' ') || undefined;
};

/**
 * Who, if anyone, holds the editor lock on `tdoId`. The single reader of the
 * TDO-lock SDO for every delete guard: VE-30856 was the folder/case guard
 * still parsing the pre-GLC-4517 `searchMedia` response shape after the query
 * moved to `structuredDataObjects`, so it never saw a lock and a request could
 * be deleted out from under its editor.
 */
const readTdoLockState = async ({
  authorization,
  schemaId,
  tdoId,
  userId,
}: {
  authorization: ReturnType<typeof getLockAuthorization>;
  schemaId: string;
  tdoId: string;
  userId: string | undefined;
}): Promise<TdoLockRead> => {
  let tdoLockData;
  try {
    tdoLockData = await fetchGraphQLApi<{
      structuredDataObjects: {
        records: Array<{ data: UpdateTDOLockResponse }>;
      };
    }>({
      ...authorization,
      query: findTdoLockQuery,
      variables: { schemaId, tdoId },
    });
  } catch {
    // A rejected fetch or an unparseable body. Same verdict as a GraphQL
    // error: we did not learn anything about this TDO.
    return { state: 'unknown' };
  }

  const records = tdoLockData?.data?.structuredDataObjects?.records;
  if (tdoLockData?.errors?.length || !records) {
    return { state: 'unknown' };
  }

  const tdoLock = records.find(({ data }) => isTdoLockFresh(data))?.data;
  return tdoLock && tdoLock.userId !== userId
    ? { state: 'lockedByOther', heldBy: lockHolderName(tdoLock.name) }
    : { state: 'unlocked' };
};

/**
 * A ceiling on how many pages a scan will read before it gives up and refuses
 * rather than guess. With the server windowing the result to the liveness
 * period, reaching this means the org holds more than 500 files open at once —
 * which is a different problem, and not one to resolve by deleting somebody's
 * work.
 */
const LOCK_PAGE_LIMIT = 10;

/**
 * How far back the lock read asks the server to look. DELIBERATELY MUCH WIDER
 * THAN THE LIVENESS RULE, which stays `isTdoLockFresh` — five refresh periods,
 * applied to each record once it arrives.
 *
 * The cutoff is computed from the DELETER'S browser clock and compared against
 * `modifiedAt`, a server timestamp. At exactly five refresh periods there is no
 * room between them: a workstation running ten minutes fast sends a cutoff in
 * the server's future, gets back nothing, and the guard concludes the subtree
 * is free — one bad clock reopening the fail-open this guard exists to close.
 *
 * An hour is slack for that skew and nothing else. Its only job is to keep the
 * read off the registry's whole accumulated history, and a dead record that
 * slips inside it is still dropped by the liveness rule.
 */
const LOCK_READ_WINDOW_MS = LOCK_REFRESH * 60;

/** A live lock held by somebody else, and whom. */
interface ActiveLock {
  readonly tdoId: string;
  readonly heldBy?: string;
}

/**
 * Every file in the org that somebody ELSE currently has open.
 *
 * This is the read that replaced one-query-per-file. It is bounded by how many
 * files are open across the org right now — a handful — rather than by how
 * many files the reviewer is deleting, which is what made a folder delete cost
 * thousands of round trips.
 *
 * Returns undefined for "we did not learn anything", which every caller must
 * treat as a refusal: a lock scan that silently came back short is the
 * fail-open VE-30856 was about.
 */
const readActiveTdoLocks = async ({
  authorization,
  schemaId,
  userId,
}: {
  authorization: ReturnType<typeof getLockAuthorization>;
  schemaId: string;
  userId: string | undefined;
}): Promise<ActiveLock[] | undefined> => {
  const active: ActiveLock[] = [];
  let offset = 0;
  // The server's own window, so paging ends when the records do rather than
  // when we judge one too old. A narrowing, not the rule — see
  // LOCK_READ_WINDOW_MS. UTC with a Z, as every aiWARE DateTime is.
  const fromDateTime = new Date(Date.now() - LOCK_READ_WINDOW_MS).toISOString();

  for (let page = 0; page < LOCK_PAGE_LIMIT; page += 1) {
    let response;
    try {
      response = await fetchGraphQLApi<{
        structuredDataObjects: {
          count?: number;
          records: Array<{ data: UpdateTDOLockResponse }>;
        };
      }>({
        ...authorization,
        query: findActiveTdoLocksQuery,
        variables: {
          schemaId,
          limit: TDO_LOCK_PAGE_SIZE,
          offset,
          fromDateTime,
        },
      });
    } catch {
      return undefined;
    }
    const list = response?.data?.structuredDataObjects;
    const records = list?.records;
    if (response?.errors?.length || !records) {
      return undefined;
    }

    for (const { data } of records) {
      // A record with no userId is somebody's, and not demonstrably ours:
      // `undefined !== undefined` would quietly file it under our own locks.
      const isOwn = !!userId && !!data?.userId && data.userId === userId;
      if (data?.tdoId && isTdoLockFresh(data) && !isOwn) {
        active.push({
          // `data` is JSONData: nothing makes the writer store this as a
          // string, and a number here would miss every `has()` downstream.
          tdoId: String(data.tdoId),
          heldBy: lockHolderName(data.name),
        });
      }
    }

    // ADVANCE BY WHAT WE GOT, NOT BY WHAT WE ASKED FOR. `count` is selected
    // precisely because the server need not honour our `limit` — so computing
    // the next offset from that same limit contradicts it. A server capping
    // the page at its own default would leave a gap between the end of one
    // page and the start of the next, and a live lock inside that gap is
    // invisible while the scan still reports success.
    offset += records.length;
    if (
      records.length === 0 ||
      (typeof list?.count === 'number'
        ? offset >= list.count
        : records.length < TDO_LOCK_PAGE_SIZE)
    ) {
      return active;
    }
  }
  // Still going after LOCK_PAGE_LIMIT pages of live locks. We cannot say we
  // have seen them all, and guessing here is the fail-open this guard exists
  // to remove.
  return undefined;
};

/** One folder a file can be reached through. */
interface LockedTdoFolder {
  id?: string;
  treeObjectId?: string;
  name?: string;
  /** Its ancestors, root first — where `folders` alone stops. */
  folderPath?: ReadonlyArray<{
    id?: string;
    treeObjectId?: string;
    name?: string;
  }>;
}

/** A locked file, and the folder it is filed in with that folder's ancestry. */
interface LockedTdoContext {
  readonly tdoId: string;
  readonly fileName?: string;
  readonly folders: ReadonlyArray<LockedTdoFolder>;
}

/**
 * Every folder the file can be reached through: the one it is filed in, and
 * each of that folder's ancestors.
 *
 * Deleting a folder deletes everything under it, so the file is in the way at
 * ANY depth, not only when it is filed directly in the target. Matching on the
 * filed folder alone caught a request delete and let the delete of the folder
 * above it through.
 */
const lockedTdoFolderIds = (context: LockedTdoContext): string[] =>
  context.folders.flatMap((folder) =>
    [folder, ...(folder.folderPath || [])].flatMap((entry) =>
      [entry.id, entry.treeObjectId].filter((id): id is string => !!id)
    )
  );

/**
 * Where each locked file lives. One read for all of them — `temporalDataObjects`
 * takes a list of ids, so this does not reintroduce a per-file query.
 */
const readLockedTdoContext = async ({
  authorization,
  tdoIds,
}: {
  authorization: ReturnType<typeof getLockAuthorization>;
  tdoIds: readonly string[];
}): Promise<LockedTdoContext[] | undefined> => {
  const contexts: LockedTdoContext[] = [];
  const resolved = new Set<string>();

  // IN BATCHES, for the same reason the lock scan pages: asking for 500 ids in
  // one read and treating anything short as unverifiable hands the server's
  // own page cap a veto over every delete in the org.
  for (let from = 0; from < tdoIds.length; from += TDO_LOCK_PAGE_SIZE) {
    const batch = tdoIds.slice(from, from + TDO_LOCK_PAGE_SIZE);
    let response;
    try {
      response = await fetchGraphQLApi<{
        temporalDataObjects: {
          records: Array<{
            id: string;
            name?: string;
            folders?: LockedTdoFolder[];
          }>;
        };
      }>({
        ...authorization,
        query: getTdoLockContextQuery,
        variables: { ids: [...batch], limit: batch.length },
      });
    } catch {
      return undefined;
    }
    const records = response?.data?.temporalDataObjects?.records;
    if (response?.errors?.length || !records) {
      return undefined;
    }
    for (const record of records) {
      resolved.add(record.id);
      contexts.push({
        tdoId: record.id,
        fileName: record.name,
        folders: record.folders || [],
      });
    }
  }

  // A SHORT RESULT IS NOT AN ANSWER. `temporalDataObjects` carries
  // `@authListFilter(roles: [AIWARE_TDO_READ])`, which drops records the
  // caller may not read INTO the WHERE clause — they are omitted silently,
  // with no error and no partial-data flag. A file the deleter cannot read is
  // exactly the one whose lock matters: under object-level permissions a
  // supervisor can hold delete on the folder without read on a file inside
  // it, and reading the omission as "not in the way" deletes a colleague's
  // work mid-edit.
  //
  // KNOWN COST, tracked separately: the ids are every live lock in the ORG,
  // so one unreadable file open anywhere refuses this user's deletes until
  // its holder closes it. The fix is to stop resolving at all — record the
  // file's folder chain ON the lock, which the editor already fetches.
  if (tdoIds.some((tdoId) => !resolved.has(tdoId))) {
    return undefined;
  }

  return contexts;
};

/**
 * What the reviewer was trying to do, which decides the refusal's verb.
 *
 * "Cannot delete" was shown for all three, including the Move to trash that
 * every soft delete actually performs.
 */
export type LockGuardIntent = 'delete' | 'trash' | 'update';

const LEAD_BY_INTENT: Record<LockGuardIntent, string> = {
  delete: 'lockLeadDelete',
  trash: 'lockLeadTrash',
  update: 'lockLeadUpdate',
};

/**
 * The refusal for a file somebody else has open, named as far as we can name
 * it.
 *
 * VE-30856 blocked the delete but said only "file currently in use", which
 * leaves a reviewer deleting a request with no way to tell WHICH of its files
 * is open, or whom to go and ask — the complaint the merged-document gate
 * already answers by naming the holder (`projects/setLockGate.ts`).
 *
 * THE REQUEST IS NAMED TOO, because the file name alone is ambiguous in the
 * case that prompted this: a merged document takes the REQUEST'S OWN NAME,
 * unadorned (`projects/services.ts` buildProjectTdoName), so a refusal naming
 * only the file reads as though it is naming the request. It also matters when
 * the delete was aimed at a FOLDER — the open file may sit several levels
 * down, in a request the reviewer never clicked.
 *
 * Tails rather than one ICU `select` per shape: the fr-CA catalogue is
 * hand-maintained, and each of these is a flat sentence to translate. Neither
 * name is guaranteed — the single-file guard is handed a tdoId and may not
 * have the row, a listing may return a file with no name — so each drops out
 * independently, down to the bare fact of the lock.
 *
 * `name` is passed through even when empty: `lockRefusalMessage` substitutes
 * "another user", in one place, for every message that names a holder.
 */
const fileInUseMessage = ({
  intent,
  tdoId,
  fileName,
  requestName,
  heldBy,
}: {
  intent: LockGuardIntent;
  tdoId: string | undefined;
  fileName?: string;
  requestName?: string;
  heldBy?: string;
}) => {
  const leadId = LEAD_BY_INTENT[intent];
  if (!tdoId) {
    return { leadId, tailId: 'lockTailInUse' };
  }
  const tailId = requestName
    ? fileName
      ? 'lockTailRequestFile'
      : 'lockTailRequestFileById'
    : fileName
      ? 'lockTailFile'
      : 'lockTailFileById';
  return {
    leadId,
    tailId,
    values: {
      tdoId,
      name: heldBy || '',
      ...(fileName ? { fileName } : {}),
      ...(requestName ? { requestName } : {}),
    },
  };
};

/**
 * The outcome of walking a request or folder for a RUNNING ENGINE JOB. The
 * walk used to answer the lock question too; `readActiveTdoLocks` does that
 * now without a walk at all, and this is what remains.
 *
 * `isUnverifiable` carries the same meaning as `TdoLockState['unknown']` for
 * the listing queries: `childTDOs`/`childFolders` are read with the same
 * `fetchGraphQLApi`, so an errored listing arrives as an empty record set. A
 * request whose file list fails to load is not an empty request, and must not
 * be deleted on the strength of one.
 */
interface LockScanResult {
  isJobProcessing: boolean;
  isUnverifiable: boolean;
}

export const callIfTdoIsUnlocked: Thunk<{
  tdoId: string;
  /**
   * For the refusal only. Callers that already hold the row pass its name;
   * the guard does not fetch one, so the message falls back to the file id.
   */
  fileName?: string;
  /** Decides the refusal's verb. Defaults to the permanent delete. */
  intent?: LockGuardIntent;
  call: () => (dispatch: Dispatch, getState: () => any) => Promise<unknown>;
}> =
  ({ tdoId, fileName, intent = 'delete', call }) =>
  async (dispatch, getState) => {
    const schemaId = await lookupLatestTdoLockSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    const lockRead = await readTdoLockState({
      authorization: getLockAuthorization(getState),
      schemaId,
      tdoId,
      userId: selectUser(getState()).userId,
    });
    if (lockRead.state !== 'unlocked') {
      dispatch(
        TDO_IN_USE(
          lockRead.state === 'unknown'
            ? {
                leadId: LEAD_BY_INTENT[intent],
                tailId: 'lockTailUnverifiable',
              }
            : fileInUseMessage({
                intent,
                tdoId,
                fileName,
                heldBy: lockRead.heldBy,
              })
        )
      );
      return;
    }

    return await call()(dispatch, getState);
  };

export const callIfFolderCaseIsUnlocked: Thunk<{
  treeObjectId: TreeObjectId;
  isCase: boolean;
  /**
   * The name of the thing being deleted, for the refusal. Used only when it IS
   * a request (`isCase`); a folder delete takes the name of whichever nested
   * request turns out to hold the open file, read from that file's own folder
   * chain (`readLockedTdoContext`).
   */
  treeObjectName?: string;
  /** Decides the refusal's verb. Defaults to the permanent delete. */
  intent?: LockGuardIntent;
  call: () => (dispatch: Dispatch, getState: () => any) => Promise<unknown>;
}> =
  ({ treeObjectId, isCase, treeObjectName, intent = 'delete', call }) =>
  async (dispatch, getState) => {
    const defaultLimit = 1000;
    const defaultOffset = 0;
    const schemaId = await lookupLatestTdoLockSchemaId(dispatch, getState);
    if (!schemaId) {
      return;
    }
    const authorization = getLockAuthorization(getState);
    const { userId } = selectUser(getState());
    // Jobs only: the lock half of this walk is gone, answered up front by
    // readActiveTdoLocks. What is left reads `jobs { records { status } }`,
    // which rides along with the file listing at no extra query.
    const checkCaseHasActiveJob = async (
      id: string
    ): Promise<LockScanResult> => {
      const result: LockScanResult = {
        isJobProcessing: false,
        isUnverifiable: false,
      };
      const checkFiles = async (offset: number): Promise<LockScanResult> => {
        const folderData = await fetchGraphQLApi<{
          folder: Partial<FolderStateType>;
        }>({
          ...authorization,
          query: getFilesByCaseIdQuery,
          variables: { caseId: id, limit: defaultLimit, offset },
        });

        if (folderData?.errors?.length || !folderData?.data?.folder) {
          result.isUnverifiable = true;
          return result;
        }

        const tdos = folderData.data.folder.childTDOs?.records || [];
        if (tdos && tdos.length > 0) {
          for (const tdo of tdos) {
            if (tdo) {
              const status = tdo.jobs?.records?.[0]?.status;
              const activeJobsStatus = [JobStatus.Pending, JobStatus.Running];
              if (status && activeJobsStatus.includes(status)) {
                result.isJobProcessing = true;
                return result;
              }
            }
          }
          if (tdos.length === defaultLimit) {
            return await checkFiles(offset + defaultLimit);
          }
        }
        return result;
      };
      return await checkFiles(defaultOffset);
    };

    const checkFolderHasActiveJob = async (
      id: string
    ): Promise<LockScanResult> => {
      const result: LockScanResult = {
        isJobProcessing: false,
        isUnverifiable: false,
      };
      const getChildFolders = async (
        offset: number
      ): Promise<LockScanResult> => {
        const folderData = await fetchGraphQLApi<{
          folder: Partial<FolderStateType>;
        }>({
          ...authorization,
          query: getChildFoldersQuery,
          variables: { folderId: id, limit: defaultLimit, offset },
        });

        if (folderData?.errors?.length || !folderData?.data?.folder) {
          result.isUnverifiable = true;
          return result;
        }

        const folders = folderData.data.folder.childFolders?.records || [];
        if (folders && folders.length > 0) {
          const caseIds = (
            folders.filter((f) => (f?.contentTemplates?.length || 0) > 0) || []
          ).map((f) => f.id);

          if (caseIds?.length > 0) {
            for (const caseId of caseIds) {
              if (caseId) {
                const caseLockResponse = await checkCaseHasActiveJob(caseId);
                if (
                  caseLockResponse.isJobProcessing ||
                  caseLockResponse.isUnverifiable
                ) {
                  return caseLockResponse;
                }
              }
            }
          }

          const folderOnlyIds = (
            folders.filter(
              (f) => !(((f.id && f.contentTemplates?.length) || 0) > 0)
            ) || []
          ).map((f) => f.id);

          if ((folderOnlyIds?.length || 0) > 0) {
            for (const folderId of folderOnlyIds) {
              if (folderId) {
                const folderLockResponse =
                  await checkFolderHasActiveJob(folderId);
                if (
                  folderLockResponse.isJobProcessing ||
                  folderLockResponse.isUnverifiable
                ) {
                  return folderLockResponse;
                }
              }
            }
          }

          if (folders?.length === defaultLimit) {
            return await getChildFolders(offset + defaultLimit);
          }
        }
        return result;
      };
      return await getChildFolders(defaultOffset);
    };

    const refuseUnverifiable = () => {
      dispatch(
        TDO_IN_USE({
          leadId: LEAD_BY_INTENT[intent],
          tailId: 'lockTailUnverifiable',
        })
      );
    };

    // PHASE 1 — is anyone editing a file inside this? Asked of the LOCKS
    // rather than of the files: two reads, whatever the size of the tree.
    const activeLocks = await readActiveTdoLocks({
      authorization,
      schemaId,
      userId,
    });
    if (!activeLocks) {
      refuseUnverifiable();
      return;
    }

    if (activeLocks.length > 0) {
      const contexts = await readLockedTdoContext({
        authorization,
        tdoIds: activeLocks.map((lock) => lock.tdoId),
      });
      if (!contexts) {
        refuseUnverifiable();
        return;
      }

      // The target is in the way if it is the file's own folder OR any folder
      // above it — one test for a request delete and a folder delete alike, at
      // any depth. Both id fields are compared because callers name the target
      // by its treeObjectId while the folder listings use the folder id.
      const held = contexts.find((context) =>
        lockedTdoFolderIds(context).includes(treeObjectId)
      );
      if (held) {
        dispatch(
          TDO_IN_USE(
            fileInUseMessage({
              intent,
              tdoId: held.tdoId,
              fileName: held.fileName,
              // The request is the folder the file is filed in. For a request
              // delete that IS the target, whose name the caller knows.
              requestName: isCase
                ? (treeObjectName ?? held.folders[0]?.name)
                : held.folders[0]?.name,
              heldBy: activeLocks.find((lock) => lock.tdoId === held.tdoId)
                ?.heldBy,
            })
          )
        );
        return;
      }
    }

    // PHASE 2 — engine jobs, and only for a delete that cannot be undone.
    // Moving to Trash tags the file and relocates it; it destroys nothing a
    // running job could still be writing to, so it is not worth walking the
    // tree for. A permanent delete still pays for one.
    //
    // No ticket ever argued for this check: it arrived unexplained on
    // GLC-4462, which was about deletes failing. Scoping it to the
    // irreversible case is the compromise between keeping that caution and
    // making every soft delete pay for it.
    if (intent !== 'delete') {
      return await call()(dispatch, getState);
    }

    let jobResult: LockScanResult = {
      isJobProcessing: false,
      isUnverifiable: false,
    };
    try {
      jobResult = isCase
        ? await checkCaseHasActiveJob(treeObjectId)
        : await checkFolderHasActiveJob(treeObjectId);
    } catch {
      // A rejected fetch anywhere in the scan. The scan reached no verdict, so
      // neither do we.
      jobResult = { ...jobResult, isUnverifiable: true };
    }
    if (jobResult.isJobProcessing || jobResult.isUnverifiable) {
      dispatch(
        TDO_IN_USE({
          leadId: LEAD_BY_INTENT[intent],
          tailId: jobResult.isJobProcessing
            ? 'lockTailJobsProcessing'
            : 'lockTailUnverifiable',
        })
      );
      return;
    }
    return await call()(dispatch, getState);
  };

export const deleteFolderCaseAndFiles =
  <T = any>(
    query: string,
    variables: {
      id: TreeObjectId;
      folderName: string;
      isPermanentDelete?: boolean;
    },
    actionTypes: Head<Parameters<typeof callGraphQLApi<T>>>['actionTypes']
  ) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const { enableDeleteNonEmptyFolder } = selectFeatureFlags(getState());
    if (!variables.isPermanentDelete && !enableDeleteNonEmptyFolder) {
      const res = await callGraphQLApi<FetchSubFoldersQueryResponse>({
        actionTypes: [
          CHECK_EMPTY_FOLDER_REQUEST,
          CHECK_EMPTY_FOLDER_SUCCESS,
          CHECK_EMPTY_FOLDER_FAILURE,
        ],
        query: fetchSubFoldersQuery,
        variables: {
          folderId: variables.id,
          limit: 1,
          offset: 0,
        },
        dispatch,
        getState,
        throwOnError: false,
        // Selects nested contentTemplates { sdo { data } }; tolerate a dangling
        // (deleted) SDO so one bad child can't collapse this read to undefined
        // and make a non-empty folder look empty (VE-26016).
        returnPartialDataOnNotFound: true,
      });

      // VE-31036: subfolders block the delete; FILES deliberately do not. The
      // cascade below is what removes a case's files, so blocking on them here
      // would stop the cascade ever running.
      //
      // VE-21114 added a v2-gated child-TDO count at this point, to block a
      // non-empty case "with a clear message instead of an opaque API failure"
      // under v2's hard delete. It read the flag off `selectFeatureFlags`,
      // which org metadata never reaches, so it only ever evaluated for an org
      // that had explicitly registered the app config. Pointing it at
      // `selectV2FoldersEnabled` with the rest of this cleanup would have
      // switched it on for every v2 org — and it returns BEFORE the cascade,
      // making a case that contains files undeletable through the UI.
      //
      // Removed rather than relocated: after the cascade there is nothing left
      // for it to guard, and it gave no protection even where it did run. It
      // reused the same `throwOnError: false` read as the cascade, and
      // `hasFiles = (count ?? 0) > 0` collapses an undefined response to "no
      // files" — so the one case it could have caught (a listing this function
      // cannot read) is exactly the case it waved through.
      //
      // Do NOT read this as "deleteFolder is only ever called on an empty
      // case". It is not: `getFiles` treats an unreadable listing as success
      // (callGraphQLApi returns undefined without throwing on a nested
      // not_found), so the mutation can still run with files present. Nor does
      // every cascade failure report — a `getFiles` throw returns without
      // dispatching anything at all. Both predate this change and are logged
      // as follow-ups on VE-31139; neither is affected by removing the guard.
      //
      // Blocking deletion of a case that still contains files would be a
      // deliberate product change, and there is a real inconsistency to settle
      // first: `enableDeleteNonEmptyFolder` is described as covering files, and
      // FolderColumn's hard-delete dialog already tells v2 users the request
      // "must be empty", while the check here has only ever counted subfolders.
      if (
        res?.folder?.childFolders?.count &&
        res.folder.childFolders.count > 0
      ) {
        dispatch(
          enqueueSnackbar({
            message: `Folder ${variables.folderName} must be empty to delete!`,
            variant: 'error',
          })
        );
        return;
      }
    }
    const defaultLimit = 1000;
    const defaultOffset = 0;
    let tdoIds: Array<string> = [];
    let isDeleteFilesSuccess = false;
    const getFiles = async (offset: number): Promise<boolean> => {
      try {
        const result = await callGraphQLApi<FetchCaseContentsQueryResponse>({
          actionTypes: [NOOP, NOOP, NOOP],
          query: fetchCaseContentsQuery,
          variables: {
            caseId: variables.id,
            limit: 1000,
            offset,
          },
          dispatch,
          getState,
          throwOnError: false,
        });
        if (result) {
          const newTdos = (result.folder.childTDOs.records || []).map(
            (r) => r.id
          );
          if (arrayHasContents(newTdos)) {
            tdoIds = uniq([...tdoIds, ...newTdos]);
            if (newTdos.length === defaultLimit) {
              return await getFiles(offset + defaultLimit);
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      } catch (err) {
        console.log(err);
        return false;
      }
      return true;
    };
    const isSuccess = await getFiles(defaultOffset);
    if (isSuccess) {
      if (tdoIds.length > 0) {
        const deleteFilesQuery = `mutation deleteTDOs {
          ${tdoIds
            .map(
              (tdoId, index) => `
              i${index}: deleteTDO(id: "${tdoId}") {
                id
              }`
            )
            .join(',')}
        }`;
        try {
          const deletedIds = await callGraphQLApi({
            actionTypes: [NOOP, NOOP, NOOP],
            query: deleteFilesQuery,
            variables: {},
            dispatch,
            getState,
            throwOnError: false,
          });
          console.log('deletedIds: ' + JSON.stringify(deletedIds));
          isDeleteFilesSuccess = true;
          // VE-28551: deleteTDO cascades to none of a file's structured data,
          // and deleting a request deletes every file inside it — so without
          // this, emptying one request strands the side data of all of them at
          // once. Best-effort and after the fact, like every other purge.
          //
          // Purge only what the server said it deleted, NOT what we asked it
          // to. A single `not_found` in the batch makes callGraphQLApi return
          // undefined WITHOUT throwing (see its errorNotFoundAfterFailure
          // branch), so a stale listing holding one already-deleted file and
          // one the caller may not delete would otherwise hard-delete the
          // second file's history and comments while the file itself lives on.
          purgeSideDataForDeletedTdos(dispatch, deletedIds);
        } catch (err) {
          console.log(err);
          isDeleteFilesSuccess = false;
        }
      } else {
        isDeleteFilesSuccess = true;
      }
      if (isDeleteFilesSuccess) {
        await callGraphQLApi<T>({
          actionTypes,
          query,
          variables,
          dispatch,
          getState,
        });
      } else {
        dispatch(DELETE_FOLDER_FAILURE(undefined, { variables }));
      }
    }
  };

export const deleteFolderAndSubfolders =
  <T = any>(
    query: string,
    variables: {
      id: TreeObjectId;
      folderName: string;
      isPermanentDelete?: boolean;
    },
    actionTypes: Head<Parameters<typeof callGraphQLApi<T>>>['actionTypes']
  ) =>
  async (dispatch: Dispatch, getState: () => any) => {
    const defaultLimit = 1000;
    const defaultOffset = 0;
    // VE-21114: under v2 the deleteFolder mutation must reference the folder id
    // (OLP), not the deprecated treeObjectId. Reads (child fetch) still accept
    // treeObjectId, so only the delete-node id switches.
    //
    // VE-31036: reads the org metadata. This used to read selectFeatureFlags,
    // which the org flag never reaches — so on a v2 org the DESCENDANTS in this
    // recursive walk were still deleted by treeObjectId (not_allowed) while the
    // saga resolved the top-level target correctly. A folder with subfolders
    // deleted its parent and failed on the children.
    const isV2Folders = selectV2FoldersEnabled(getState());

    type ChildFolderRecord =
      FetchSubFoldersQueryResponse['folder']['childFolders']['records'][number];

    // Lazily resolve the case schema id only when we actually find a
    // case in the tree, so we don't pay for the lookup on pure folder
    // hierarchies. The result is cached for subsequent cases.
    let caseSchemaIdCache: string | null | undefined;
    const getCaseSchemaId = async (): Promise<string | null> => {
      if (caseSchemaIdCache !== undefined) {
        return caseSchemaIdCache;
      }
      const id = await lookupLatestCaseSchemaId(dispatch, getState);
      caseSchemaIdCache = id || null;
      return caseSchemaIdCache;
    };

    const fetchAllChildFolders = async (
      folderId: TreeObjectId
    ): Promise<ChildFolderRecord[] | null> => {
      const records: ChildFolderRecord[] = [];
      const fetchPage = async (offset: number): Promise<boolean> => {
        try {
          const result = await callGraphQLApi<FetchSubFoldersQueryResponse>({
            actionTypes: [NOOP, NOOP, NOOP],
            query: fetchSubFoldersQuery,
            variables: { folderId, limit: defaultLimit, offset },
            dispatch,
            getState,
            throwOnError: false,
            // Selects nested contentTemplates { sdo { data } }; tolerate a
            // dangling (deleted) SDO so one bad child can't collapse this read
            // to undefined and silently truncate the subtree walk (VE-26016).
            returnPartialDataOnNotFound: true,
          });
          const childRecords = result?.folder?.childFolders?.records;
          if (arrayHasContents(childRecords)) {
            records.push(...childRecords);
            if (childRecords.length === defaultLimit) {
              return await fetchPage(offset + defaultLimit);
            }
          }
          return true;
        } catch (err) {
          console.error('Failed to fetch child folders for', folderId, err);
          return false;
        }
      };
      const ok = await fetchPage(defaultOffset);
      return ok ? records : null;
    };

    const deleteCaseTdos = async (caseId: TreeObjectId): Promise<boolean> => {
      let tdoIds: string[] = [];
      const collectTdos = async (offset: number): Promise<boolean> => {
        try {
          const result = await callGraphQLApi<FetchCaseContentsQueryResponse>({
            actionTypes: [NOOP, NOOP, NOOP],
            query: fetchCaseContentsQuery,
            variables: { caseId, limit: defaultLimit, offset },
            dispatch,
            getState,
            throwOnError: false,
          });
          if (result) {
            const newTdos = (result.folder.childTDOs.records || []).map(
              (r) => r.id
            );
            if (arrayHasContents(newTdos)) {
              tdoIds = uniq([...tdoIds, ...newTdos]);
              if (newTdos.length === defaultLimit) {
                return await collectTdos(offset + defaultLimit);
              }
            }
          }
          return true;
        } catch (err) {
          console.error('Failed to fetch TDOs for case', caseId, err);
          return false;
        }
      };

      const collected = await collectTdos(defaultOffset);
      if (!collected) {
        return false;
      }
      if (tdoIds.length === 0) {
        return true;
      }
      const deleteFilesQuery = `mutation deleteTDOs {
        ${tdoIds
          .map(
            (tdoId, index) => `
            i${index}: deleteTDO(id: "${tdoId}") {
              id
            }`
          )
          .join(',')}
      }`;
      try {
        const deletedIds = await callGraphQLApi({
          actionTypes: [NOOP, NOOP, NOOP],
          query: deleteFilesQuery,
          variables: {},
          dispatch,
          getState,
          throwOnError: false,
        });
        // VE-28551: same as the case path above — the files are gone, their
        // per-TDO SDOs are not, and nothing else will come back for them. And
        // the same caveat: only what the server reported deleted.
        purgeSideDataForDeletedTdos(dispatch, deletedIds);
        return true;
      } catch (err) {
        console.error('Failed to delete TDOs for case', caseId, err);
        return false;
      }
    };

    const deleteFolderNode = async (
      folderId: string, // VE-21114: treeObjectId (v1) or folder id (v2)
      folderName: string
    ): Promise<boolean> => {
      try {
        await callGraphQLApi({
          actionTypes: [NOOP, NOOP, NOOP],
          query: deleteFolderOrCaseQuery,
          variables: { id: folderId, folderName },
          dispatch,
          getState,
          throwOnError: true,
        });
        return true;
      } catch (err) {
        console.error('Failed to delete folder', folderId, err);
        return false;
      }
    };

    // Remove every structured-data object attached to a case folder.
    // Mirrors the behaviour of `deleteCaseSdo` which is what the UI
    // dispatches when a case is deleted directly.
    const deleteCaseSdos = async (
      record: ChildFolderRecord
    ): Promise<boolean> => {
      const contentTemplates = (record.contentTemplates || []).filter(
        (contentTemplate) => !!contentTemplate?.sdoId
      );
      if (contentTemplates.length === 0) {
        return true;
      }
      const schemaId = await getCaseSchemaId();
      if (!schemaId) {
        console.error(
          'Failed to resolve case schema id while deleting',
          record.id
        );
        return false;
      }
      for (const contentTemplate of contentTemplates) {
        try {
          const response = await callGraphQLApi<DeleteSdoQueryResponse>({
            actionTypes: [NOOP, NOOP, NOOP],
            query: deleteSdoQuery,
            variables: { sdoId: contentTemplate.sdoId, schemaId },
            dispatch,
            getState,
            throwOnError: true,
          });
          if (response?.deleteStructuredData?.id !== contentTemplate.sdoId) {
            console.error(
              'Unexpected response when deleting SDO',
              contentTemplate.sdoId,
              response
            );
            return false;
          }
        } catch (err) {
          console.error('Failed to delete SDO', contentTemplate.sdoId, err);
          return false;
        }
      }
      return true;
    };

    const isCaseRecord = (record: ChildFolderRecord) =>
      (record?.contentTemplates?.length || 0) > 0;

    const deleteSubtree = async (
      record: ChildFolderRecord
    ): Promise<boolean> => {
      const childId = record.treeObjectId;
      // Reads accept treeObjectId under v2; the delete mutation needs the id.
      const deleteId = resolveFolderMutationId(isV2Folders, {
        folderId: record.id,
        treeObjectId: record.treeObjectId,
      });
      if (isCaseRecord(record)) {
        const sdosDeleted = await deleteCaseSdos(record);
        if (!sdosDeleted) {
          return false;
        }
        const tdosDeleted = await deleteCaseTdos(childId);
        if (!tdosDeleted) {
          return false;
        }
        return await deleteFolderNode(deleteId, record.name);
      }

      const grandChildren = await fetchAllChildFolders(childId);
      if (grandChildren === null) {
        return false;
      }
      for (const grandChild of grandChildren) {
        const ok = await deleteSubtree(grandChild);
        if (!ok) {
          return false;
        }
      }
      return await deleteFolderNode(deleteId, record.name);
    };

    const { enableDeleteNonEmptyFolder } = selectFeatureFlags(getState());
    if (!variables.isPermanentDelete && !enableDeleteNonEmptyFolder) {
      const res = await callGraphQLApi<FetchSubFoldersQueryResponse>({
        actionTypes: [
          CHECK_EMPTY_FOLDER_REQUEST,
          CHECK_EMPTY_FOLDER_SUCCESS,
          CHECK_EMPTY_FOLDER_FAILURE,
        ],
        query: fetchSubFoldersQuery,
        variables: {
          folderId: variables.id,
          limit: 1,
          offset: 0,
        },
        dispatch,
        getState,
        throwOnError: false,
        // Selects nested contentTemplates { sdo { data } }; tolerate a dangling
        // (deleted) SDO so one bad child can't collapse this read to undefined
        // and make a non-empty folder look empty (VE-26016).
        returnPartialDataOnNotFound: true,
      });

      if (
        res?.folder?.childFolders?.count &&
        res.folder.childFolders.count > 0
      ) {
        dispatch(
          enqueueSnackbar({
            message: `Folder ${variables.folderName} must be empty to delete!`,
            variant: 'error',
          })
        );
        return;
      }
    }

    const topLevelChildren = await fetchAllChildFolders(variables.id);
    if (topLevelChildren === null) {
      dispatch(DELETE_FOLDER_FAILURE(undefined, { variables }));
      return;
    }

    for (const child of topLevelChildren) {
      const ok = await deleteSubtree(child);
      if (!ok) {
        dispatch(DELETE_FOLDER_FAILURE(undefined, { variables }));
        return;
      }
    }

    await callGraphQLApi<T>({
      actionTypes,
      query,
      variables,
      dispatch,
      getState,
    });
  };

/**
 * VE-28061: the same output-asset read as `fetchStalenessAssets`, but routed
 * through the action lifecycle so the reducer can patch the rows in place
 * (REFRESH_FILE_OUTPUTS_SUCCESS). Partial-data tolerant: one purged TDO must not
 * blank the refresh for the others.
 */
export const fetchFileOutputs = (tdoIds: NonEmptyArray<TDOId>) =>
  invokeGqlCall<StalenessAssetsResponse>(
    fetchStalenessAssetsQuery(tdoIds),
    // The query aliases the ids inline rather than binding them, so the server
    // ignores these. Passed anyway because callGraphQLApi attaches request
    // variables to the failure action's meta, which is how the retry in
    // `refreshFileOutputsFailure` recovers which files to ask for again.
    { tdoIds },
    [
      REFRESH_FILE_OUTPUTS_INIT,
      REFRESH_FILE_OUTPUTS_SUCCESS,
      REFRESH_FILE_OUTPUTS_FAILURE,
    ],
    { returnPartialDataOnNotFound: true }
  );

/**
 * Fetch one TDO's `media` assets, so a download can pick between the ingested
 * file and the searchable copy the OCR engine republished.
 *
 * Returns `[]` on failure rather than throwing: the caller falls back to the
 * asset the folder already loaded, which is the pre-existing behaviour and a
 * working download, rather than nothing happening when the user clicks.
 */
export const fetchMediaAssets =
  (tdoId: TDOId) =>
  async (
    dispatch: Dispatch,
    getState: () => any
  ): Promise<{
    media: MediaAssetRecord[];
    originalFormat: MediaAssetRecord[];
  }> => {
    try {
      const response = await callGraphQLApi<MediaAssetsResponse>({
        actionTypes: [NOOP, NOOP, NOOP],
        query: fetchMediaAssetsQuery,
        variables: { id: tdoId },
        dispatch,
        getState,
        throwOnError: true,
      });
      return {
        media: response?.temporalDataObject?.assets?.records ?? [],
        originalFormat:
          response?.temporalDataObject?.originalFormatAssets?.records ?? [],
      };
    } catch (err) {
      console.warn(
        'Media asset fetch failed; downloading the loaded asset instead',
        err
      );
      return { media: [], originalFormat: [] };
    }
  };

/**
 * Fetch the assets a staleness verdict needs, keyed by TDO id (VE-25870).
 *
 * Called when the user asks to download, not when the folder opens: the verdict
 * should reflect what is true at download time, and browsing shouldn't pay for
 * it. Returns `{}` on failure — the caller then judges from what the row already
 * has, which is the pre-existing behaviour rather than a blocked download.
 */
export const fetchStalenessAssets =
  (tdoIds: TDOId[]) =>
  async (
    dispatch: Dispatch,
    getState: () => any
  ): Promise<Record<string, StalenessAssetsResponse[string]>> => {
    if (!arrayHasContents(tdoIds)) {
      return {};
    }
    try {
      const response = await callGraphQLApi<StalenessAssetsResponse>({
        actionTypes: [NOOP, NOOP, NOOP],
        query: fetchStalenessAssetsQuery(tdoIds),
        variables: {},
        dispatch,
        getState,
        throwOnError: true,
      });
      const byTdoId: Record<string, StalenessAssetsResponse[string]> = {};
      for (const value of Object.values(response ?? {})) {
        if (value?.id) {
          byTdoId[value.id] = value;
        }
      }
      return byTdoId;
    } catch (err) {
      console.warn(
        'Staleness asset fetch failed; judging from loaded data',
        err
      );
      return {};
    }
  };
